<template>
    <div id="app" ref="app" :class="[{ notScroll: isWeaponFilter || isSkinSort, bindingPage: needLogin && riotBindingPageEnabled }]">
        <details v-if="riotDebugEnabled" class="riotDiagnostics" :open="riotDiagnosticFailed">
            <summary>Riot 绑定诊断 · 20260914-d1</summary>
            <button type="button" :disabled="!riotDiagnosticText" @click="selectRiotDiagnosticLog">全选日志</button>
            <textarea ref="riotDiagnosticLog" readonly aria-label="Riot 绑定诊断日志" :value="riotDiagnosticText"></textarea>
        </details>
        <!-- <div class="MaskUpgradeVersionTemplate" @click="Upgrade" v-show="VersionInterceptionDisplay"></div> -->
        <div class="contentArea" :class="{ bindingLanding: riotBindingPageEnabled }" v-if="needLogin">
            <valorant-binding-page
                v-if="riotBindingPageEnabled"
                :busy="loading || riotBinding || binding || authorizationPolling || quickBindLoading"
                :tracker-open.sync="trackerBindingFormOpen"
                :account.sync="account"
                @official-login="onOfficialLogin()"
                @tracker-login="openTrackerBindingForm()"
                @tracker-submit="submitTrackerBinding()"
            />
            <transition name="fade" v-else>
                <div class="container">
                    <div class="loading" v-if="loading"></div>
                    <div class="topTips">部分用户无法绑定的问题现已修复，可重试登录</div>

                    <input type="text" v-model="account" placeholder="输入游戏昵称，如player#01" />
                    <div class="quickInput" v-if="accountList && accountList.length > 0">
                        <div class="label">账号快捷输入：</div>
                        <div class="accountList">
                            <span v-for="accountItem in accountList" :key="accountItem" @click="account = accountItem">{{ accountItem }}</span>
                        </div>
                    </div>
                    <div class="bindBtn" @click="bind()">立即绑定</div>
                    <div v-if="riotRouteEnabled" class="riotBindBtn" :aria-disabled="riotBinding" @click="bindRiotAccount()">拳头登录</div>
                    <div class="tips">
                        <div class="tip-line-1">当前仅支持国际服用户查询</div>
                        <div class="tip-line-2">{{ riotRouteEnabled ? "战绩数据由Tracker或Riot提供" : "战绩数据由Tracker提供" }}</div>
                    </div>
                </div>
            </transition>
        </div>
        <transition name="fade" v-else>
            <div class="mainArea">
                <div class="loading" v-if="loading"></div>
                <div class="loadingTxt" v-if="loading">
                    <span>数据加载中</span>
                    该过程视网络情况可能会持续数秒至数十秒若多次不成功,<br />可尝试在【设置-游戏账号管理】解绑后重新绑定
                </div>
                <div class="loadError" v-if="loadError">
                    <div class="dataErrorTips">当前账号数据加载失败！</div>
                    <div class="reloadDataBtn" @click="getInfo()">重新加载</div>
                </div>
                <div class="inquiryInfo" v-if="!loading && valorantTrackerInfo">
                    <!-- 顶部用户信息 -->
                    <div class="accountInfo">
                        <div class="infoPhoto">
                            <img v-if="valorantTrackerInfo.headImageUrl" :src="valorantTrackerInfo.headImageUrl" alt="" />
                            <div v-if="showRefreshControl" class="refreshInfo" :class="{ isFreshing: isFreshing }" @click="getInfo(true)">
                                <i></i>{{ isFreshing ? "正在更新" : "点击更新" }}
                            </div>
                        </div>
                        <div class="infoAccount">
                            <div class="infoTitle">
                                <div class="accountName">
                                    <span class="title">{{ valorantTrackerInfo.valorantUserNameCaption }}</span>
                                    <div class="accountMeta">
                                        <span class="ltitle">{{ valorantTrackerInfo.valorantUserNameSuffix }}</span>
                                        <span class="level">Lv.{{ formatDisplayValue(valorantTrackerInfo.level, 0) }}</span>
                                    </div>
                                </div>
                                <span v-if="isCurrentUser" class="changeIcon" @click="changeAccount()">切换账号</span>
                            </div>
                            <div class="infoFilters">
                                <div
                                    class="modeOptions"
                                    :class="{ riot: currentDataSource === 'RIOT_PD' }"
                                    role="tablist"
                                    aria-label="比赛模式"
                                >
                                    <button
                                        v-for="modeOption in visibleModeOptions"
                                        :key="modeOption.code"
                                        type="button"
                                        class="mode-option"
                                        :class="{ active: isModeActive(modeOption) }"
                                        :aria-selected="isModeActive(modeOption) ? 'true' : 'false'"
                                        role="tab"
                                        @click="selectModeOption(modeOption)"
                                    >{{ modeOption.caption }}</button>
                                    <button
                                        v-if="otherModeOptions.length"
                                        type="button"
                                        class="mode-option mode-more"
                                        :class="{ active: isOtherModeActive }"
                                        :aria-selected="isOtherModeActive ? 'true' : 'false'"
                                        aria-haspopup="menu"
                                        role="tab"
                                        @click="selectOtherMode()"
                                    ><span>其他</span><i></i></button>
                                </div>
                                <button type="button" class="season-filter" @click="selectSeason()">
                                    <span>{{ selectSeasons }}</span>
                                    <i></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="profileCaption">
                        <template v-if="currentDataSource === 'RIOT_PD'">首次绑定，本战绩目前仅能支持近50场</template>
                        <template v-else>
                            上次更新：{{ getTimeDiff(new Date(valorantTrackerInfo.updateTime).getTime(), new Date().getTime()) }}
                        </template>
                    </div>

                    <div class="levelGrid">
                        <div class="grid1">
                            <img v-if="valorantTrackerInfo.segmentImageUrl" :src="valorantTrackerInfo.segmentImageUrl" alt="" />
                            <img v-else class="noImg" src="https://image.gamersky.com/webimg13/valorant_track/question-icon.svg" alt="暂无段位" />
                            <div>
                                <p class="rrNum" :class="{ noDataValue: valorantTrackerInfo.rr == '-' }">
                                    {{ formatDisplayValue(valorantTrackerInfo.rr, 0) }}<span>RR</span>
                                </p>
                                <p>{{ valorantTrackerInfo.segmentsCn }}</p>
                            </div>
                        </div>
                        <div class="grid2">
                            <div class="victoriyOrLoseCount">
                                <span class="victoryCount" :class="{ noDataValue: valorantTrackerInfo.allWins == '-' }">{{
                                    formatDisplayValue(valorantTrackerInfo.allWins, 0)
                                }}</span>
                                <span class="splitLine"></span>
                                <span class="loseCount" :class="{ noDataValue: valorantTrackerInfo.allLose == '-' }">{{
                                    formatDisplayValue(valorantTrackerInfo.allLose, 0)
                                }}</span>
                            </div>
                            <div class="victoriyOrLose">
                                <i class="winProgress" :style="{ flexGrow: calcRate('win') }"></i>
                                <i class="loseProgress" :style="{ flexGrow: calcRate('lose') }"></i>
                            </div>
                        </div>
                        <div class="grid3">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.damagePerRound == '-' }">
                                {{ formatDisplayValue(valorantTrackerInfo.damagePerRound) }}
                            </p>
                            <p class="inquryText">回合伤害</p>
                        </div>
                        <div class="grid4">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.kdRatio == '-' }">{{ formatDisplayValue(valorantTrackerInfo.kdRatio, 2) }}</p>
                            <p class="inquryText">K/D</p>
                        </div>
                        <div class="grid5">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.headshotRate == '-' }">
                                {{ formatDisplayValue(valorantTrackerInfo.headshotRate) }}
                            </p>
                            <p class="inquryText">爆头率</p>
                        </div>
                        <div class="grid6">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.winRate == '-' }">{{ formatDisplayValue(valorantTrackerInfo.winRate) }}</p>
                            <p class="inquryText">胜率</p>
                        </div>
                    </div>
                    <div class="inquiryGrid" v-if="collapse">
                        <div class="grid2">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.killsPerRound == '-' }">
                                {{ formatDisplayValue(valorantTrackerInfo.killsPerRound) }}
                            </p>
                            <p class="inquryText">回合击杀数</p>
                        </div>
                        <div class="grid3">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.ddr == '-' }">{{ formatDisplayValue(valorantTrackerInfo.ddr) }}</p>
                            <p class="inquryText">DDR</p>
                        </div>
                        <div class="grid4">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.kast == '-' }">{{ formatDisplayValue(valorantTrackerInfo.kast) }}</p>
                            <p class="inquryText">KAST</p>
                        </div>
                        <div class="grid5">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.acs == '-' }">{{ formatDisplayValue(valorantTrackerInfo.acs) }}</p>
                            <p class="inquryText">每回合均分数</p>
                        </div>
                        <div class="grid6">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.kills == '-' }">{{ formatDisplayValue(valorantTrackerInfo.kills, 0) }}</p>
                            <p class="inquryText">击杀数</p>
                        </div>
                        <div class="grid7">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.deaths == '-' }">{{ formatDisplayValue(valorantTrackerInfo.deaths, 0) }}</p>
                            <p class="inquryText">死亡数</p>
                        </div>
                        <div class="grid8">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.assists == '-' }">{{ formatDisplayValue(valorantTrackerInfo.assists, 0) }}</p>
                            <p class="inquryText">助攻数</p>
                        </div>
                        <div class="grid9">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.flawless == '-' }">
                                {{ formatDisplayValue(valorantTrackerInfo.flawless, 0) }}
                            </p>
                            <p class="inquryText">无暇数</p>
                        </div>
                        <div class="grid10">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.aces == '-' }">{{ formatDisplayValue(valorantTrackerInfo.aces, 0) }}</p>
                            <p class="inquryText">团灭数</p>
                        </div>
                        <div class="grid11">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.matches == '-' }">{{ formatDisplayValue(valorantTrackerInfo.matches, 0) }}</p>
                            <p class="inquryText">总比赛场次</p>
                        </div>
                        <div class="grid10">
                            <p class="inquryValue" :class="{ noDataValue: valorantTrackerInfo.playTime == '-' }">
                                {{ formatPlayTime(valorantTrackerInfo.playTime) }}
                            </p>
                            <p class="inquryText">游戏时长</p>
                        </div>
                        <div></div>
                    </div>
                    <div class="closepall" @click="closepall()">{{ collapse ? "收起" : "展开" }}<i class="down" :class="{ up: !!collapse }"></i></div>
                    <valorant-record-sections
                        :key="`${valorantTrackerInfo.id || valorantTrackerInfo.valorantUserName || ''}|${selectModes}|${selectSeasons}`"
                        :tracker-info="valorantTrackerInfo"
                        :match-navigation-enabled="true"
                        :show-weapons="currentDataSource === 'TRACKER'"
                        @open-list="toList"
                        @open-match="ToDetail"
                    />
                </div>
            </div>
        </transition>
        <valorant-quick-bind-popup
            v-if="riotQuickBindEnabled"
            :value="quickBindOpen"
            :accounts="quickBindAccounts"
            :busy="quickBindBusy"
            :loading="quickBindLoading"
            :error="quickBindError"
            :progress="quickBindProgress"
            @input="setQuickBindOpen"
            @retry="loadQuickBindAccounts"
            @login="quickBindLogin"
            @confirm="startQuickBind"
        />
        <valorant-account-switch-popup
            v-model="changeAccountModel"
            :accounts="changeAccountList"
            :active-bind-info-id="currentBindInfoId"
            :active-name="account"
            :active-source="currentDataSource"
            :source-visible="riotRouteEnabled || riotBindingPageEnabled"
            :busy="accountSwitching || !!accountRemovingKey"
            @add-account="addAccount()"
            @confirm="changeAccountOption"
            @delete-account="removeBoundAccount"
        />
    </div>
</template>

<script>
/* global GSAppJsApi */
import inquiryApi from "../../assets/api/inquiryApi";
import config from "../../assets/config";
import { showAuthModal } from "@/components/authModel/authModal.js";
import ValorantAccountSwitchPopup from "../../components/ValorantAccountSwitchPopup/ValorantAccountSwitchPopup.vue";
import ValorantQuickBindPopup from "../../components/ValorantQuickBindPopup/ValorantQuickBindPopup.vue";
import ValorantRecordSections from "../../components/ValorantRecordSections/ValorantRecordSections.vue";
import ValorantBindingPage from "../../components/ValorantBindingPage/ValorantBindingPage.vue";
const {
    buildAuthorizationBridgeUrl,
    pollAuthorizationSession,
} = require("../../assets/js/valorantAuthPolling");
const {
    accountKey,
    buildBindingSelection,
    createLatestRequestGate,
    isAccountActive,
    isTrackerAccountBound,
    normalizeSource,
    shouldPreserveCurrentData,
    shouldReturnToBindingAfterRefresh,
    withTimeout,
} = require("../../assets/js/accountIdentity");
const {
    RIOT_DATA_REQUEST_TIMEOUT_MS,
    RIOT_REFRESH_COMPLETION_WAIT_MS,
    TRACKER_AUTHORIZATION_TIMEOUT_MS,
    TRACKER_DATA_REQUEST_TIMEOUT_MS,
} = require("../../assets/js/valorantRequestPolicy");
const { formatDisplayValue, formatPlayTime } = require("../../assets/js/valorantRecordDetails");
const { riotSeasonOptions } = require("../../assets/js/riotMatchPages");
const {
    buildRiotBindRequest,
    buildRiotQueryRequest,
    readRiotAccountSession,
    saveRiotRecordSession,
    shouldAutoRefreshRiot,
} = require("../../assets/js/riotAccountSession");
const { renewRiotSessionWithCookie } = require("../../assets/js/riotSessionRenewal");
const { isRiotRenewalTemporaryFailure, isRiotRenewalLoginRequired } = require("../../assets/js/riotRenewalPolicy");
const { prepareClientRequest, submitClientRequest } = require("../../assets/js/riotClientFetch");
const {
    getRiotVShopBridgeScriptUrl,
    renewRiotSessionWithVShopWebView,
} = require("../../assets/js/riotVShopSessionRenewal");
const { loginWithShopRiotDialog } = require("../../assets/js/riotShopLogin");
const { normalizeShopAccounts, runQuickBindBatch, createQuickBindProcessor, quickBindFailureMessage, isUnconfirmedRiotBindingResponse } = require("../../assets/js/riotQuickBind");
const { isTransientNetworkError } = require("../../assets/js/riotRequestRecovery");
const {
    createShopRecordLogin,
    consumeShopRecordLogin,
    cancelShopRecordLogin,
    readShopRecordLoginOutcome,
    completeShopRecordLoginOutcome,
} = require("../../../../GamerSky.Valorant/src/assets/js/recordLoginReturn");
const { readSharedSession, publishSharedSession } = require("../../../../GamerSky.Valorant/src/assets/js/riotSharedSession");
const { createRiotDiagnostics, readRiotDiagnostics, summarizeRiotError, summarizeRiotResponse } = require("../../assets/js/riotDiagnostics");
const { createRiotFlowMonitor, createTraceId, reportRiotMonitorEvent } = require("../../assets/js/riotMonitoring");

const HEADER_MODE_DEFINITIONS = [
    { code: "all", caption: "全部", aliases: ["all", "全部"] },
    { code: "competitive", caption: "竞技", aliases: ["competitive", "竞技", "竞技模式", "競技", "競技模式"] },
    { code: "unrated", caption: "一般", aliases: ["unrated", "一般", "一般模式", "非评级", "非評級"] },
    { code: "spikerush", caption: "辐能", aliases: ["spikerush", "spike-rush", "spike_rush", "辐能", "輻能", "辐能抢攻战", "輻能搶攻戰", "爆能快攻"] },
    { code: "deathmatch", caption: "死斗", aliases: ["deathmatch", "死斗", "死鬥"] },
    { code: "swiftplay", caption: "快速", aliases: ["swiftplay", "快速", "极速", "極速", "极速模式", "極速模式", "超速冲点", "超速衝點"] },
];
const PRIMARY_HEADER_MODE_CODES = new Set(["all", "competitive", "unrated"]);

function normalizeModeCode(value) {
    const normalized = String(value || "").trim().toLowerCase().replace(/\s+/g, "");
    const definition = HEADER_MODE_DEFINITIONS.find((item) => item.aliases.some((alias) => alias.toLowerCase() === normalized));
    return definition ? definition.code : normalized;
}

function isRiotSessionExpired(error) {
    if (error === 401) return true;
    const normalized = String(error || "").trim().toUpperCase();
    return normalized === "401" || normalized === "RIOT_SESSION_EXPIRED";
}

function currentGamerskyUserId() {
    try { return Number(GSAppJsApi.User.getCurrentUserId()) || 0; } catch (error) { return 0; }
}

function buildHeaderModeOptions(modes, dataSource) {
    const availableModes = Array.isArray(modes) ? modes : [];
    const seen = new Set();
    return availableModes.reduce((options, mode) => {
        const rawValue = mode && (mode.value || mode.name || mode.label);
        const code = normalizeModeCode(rawValue);
        if (!code || seen.has(code)) return options;
        if (code === "all" && normalizeSource(dataSource) !== "RIOT_PD") return options;
        const definition = HEADER_MODE_DEFINITIONS.find((item) => item.code === code);
        seen.add(code);
        options.push({
            code,
            caption: (definition && definition.caption) || mode.caption || mode.label || mode.name || rawValue,
            requestValue: rawValue,
        });
        return options;
    }, []);
}

export default {
    name: "app",
    components: {
        ValorantAccountSwitchPopup,
        ValorantQuickBindPopup,
        ValorantRecordSections,
        ValorantBindingPage,
    },
    data() {
        return {
            isWeaponFilter: false,
            isSkinSort: false,
            account: "", // 输入的账号昵称,
            accountList: [],
            loading: true,
            loadError: false,
            needLogin: false,
            isFreshing: false, // 刷新数据
            VersionInterceptionDisplay: false, //版本拦截展示

            valorantTrackerInfo: null,
            riotStatsSnapshot: null,
            riotAccountSession: null,
            riotSessionOperationStartedAt: 0,
            riotSharedSessionUpdatedAt: 0,
            riotSessionRecoveryAttempt: 0,
            collapse: false, //  是否展开
            gamerskyUserId: GSAppJsApi.User.getCurrentUserId(),
            isCurrentUser: true,

            modes: [],
            selectModes: "",

            seasons: [],
            selectSeasons: "",
            binding: false,
            didWindowGetFocus: false,
            loadedValorantTrackerInfo: false,
            isAndroid: false,
            isAppVersionGreaterThanOrEqual: false,
            changeAccountModel: false,
            changeAccountList: [],
            currentBindInfoId: null,
            currentDataSource: "TRACKER",
            currentSourceLabel: "Tracker",
            currentSourceAccountId: "",
            IsNeedLogin: false,
            NoNeedBind: false,
            pendingAuthorizationBindParams: null,
            pendingAuthorizationSessionId: "",
            authorizationPolling: false,
            authorizationFlowId: 0,
            authorizationTimer: null,
            authorizationWaitResolve: null,
            authorizationDialogOpen: false,
            authorizationLoadingToastOpen: false,
            canRefresh: true,
            nextRefreshTime: null,
            lastRefreshTime: null,
            refreshInProgress: false,
            refreshCooldownTimer: null,
            loadingDelayTimer: null,
            accountSwitching: false,
            accountRemovingKey: "",
            bindInfoRequestGate: createLatestRequestGate(),
            userDataRequestGate: createLatestRequestGate(),
            riotBindRequestGate: createLatestRequestGate(),
            riotBinding: false,
            riotBindingPageEnabled: config.riotBindingPageEnabled === true,
            riotQuickBindEnabled: config.riotQuickBindEnabled === true,
            quickBindGate: createLatestRequestGate(),
            quickBindOpen: false,
            quickBindBusy: false,
            quickBindLoading: false,
            quickBindError: "",
            quickBindAccounts: [],
            quickBindBindings: [],
            quickBindUserId: 0,
            quickBindProgress: { completed: 0, total: 0 },
            quickBindLast: null,
            riotDirectLoginRequest: null,
            trackerBindingFormOpen: false,
            pendingShopLoginId: "",
            riotRouteEnabled: config.riotRouteEnabled === true,
            riotDebugEnabled: config.riotRouteEnabled === true && config.riotDiagnosticsEnabled === true
                && /[?&]riotDebug=1(?:&|$)/.test((window.location && window.location.search) || ""),
            riotDiagnosticText: "",
            riotDiagnosticFailed: false,
        };
    },
    computed: {
        showRefreshControl() {
            return this.isCurrentUser
                && (this.isFreshing || (this.canRefresh && !this.refreshInProgress));
        },
        visibleModeOptions() {
            return buildHeaderModeOptions(this.modes, this.currentDataSource)
                .filter((option) => PRIMARY_HEADER_MODE_CODES.has(option.code));
        },
        otherModeOptions() {
            return buildHeaderModeOptions(this.modes, this.currentDataSource)
                .filter((option) => !PRIMARY_HEADER_MODE_CODES.has(option.code));
        },
        isOtherModeActive() {
            const selectedCode = normalizeModeCode(this.selectModes);
            return this.otherModeOptions.some((option) => option.code === selectedCode);
        },
    },
    watch: {
        needLogin(val) {
            if (val) this.trackerBindingFormOpen = false;
            setTimeout(() => {
                if (val && this.IsNeedLogin) {
                    GSAppJsApi.EventStatistics.recordEvent("Z100108", "", 0);
                    this.record(108, this.gamerskyUserId);
                }
            }, 1);
        },
        pendingAuthorizationSessionId(val) {
            if (val) this.trackerBindingFormOpen = false;
        },
        IsNeedLogin(val) {
            setTimeout(() => {
                if (val && this.needLogin) {
                    GSAppJsApi.EventStatistics.recordEvent("Z100108", "", 0);
                    this.record(108, this.gamerskyUserId);
                }
            }, 1);
        },
    },
    mounted() {
        let that = this;
        if (this.riotQuickBindEnabled) window.addEventListener("pagehide", this.cancelRiotEntry);
        if (this.riotDebugEnabled) {
            try { this.riotDiagnosticText = readRiotDiagnostics(window.localStorage); } catch (error) { /* Diagnostics only. */ }
        }
        const gsAppChannelParams = this.$utils.getQueryString("gsAppChannelParams");
        const shopLoginReturned = this.riotBindingPageEnabled && this.$utils.getQueryString("valorantRecordLogin");

        if (gsAppChannelParams && gsAppChannelParams != "addValorantAccount") {
            if (gsAppChannelParams != "toShangDian" && gsAppChannelParams != "toPiFuKu") {
                this.gamerskyUserId = this.$utils.getQueryString("gsAppChannelParams");
                this.isCurrentUser = false;
            }
        }
        this.DetermineVersion(); // 判断是否是 6.22.30 或以上版本
        this.$utils.reredirectPage();
        if (gsAppChannelParams == "addValorantAccount" || shopLoginReturned) {
            this.needLogin = true;
            this.loading = false;
            this.getBindAccountList();
            this.isCurrentUser = true;

            // return
        } else {
            this.getBindInfo();
            // 20251204无畏契约战绩恢复1.0 注释，后端找不到接口代码
            // this.getQuickInputList();
            if (this.isCurrentUser) {
                this.getBindAccountList();
            }
        }

        GSAppJsApi.UI.setBrowserUI("Dark", true, true);
        window.addEventListener("scroll", this.scroll);
        window.addEventListener("pageshow", this.restoreShopLoginPage);
        this.isAppVersionGreaterThanOrEqual = GSAppJsApi.Environment.isAppVersionGreaterThanOrEqual("6.22.52");
        this.isAndroid = GSAppJsApi.Environment.isInAppWebViewInAndroid();
        // 安卓端， 或 版本号大于等于 6.22.52 上报总 和 已绑定访问统计
        if (this.isAppVersionGreaterThanOrEqual || this.isAndroid) {
            GSAppJsApi.UI.didWindowGetFocus = function() {
                that.didWindowGetFocus = true;
                if (that.pendingAuthorizationSessionId) {
                    that.authorizationDialogOpen = false;
                    that.resumeAuthorizationStatusPolling("window_focus");
                }

                setTimeout(function() {
                    if (that.loadedValorantTrackerInfo) {
                        GSAppJsApi.EventStatistics.recordEvent("Z100011", "", 0);
                        GSAppJsApi.EventStatistics.recordEvent("Z100089", "无畏契约", 0);
                        GSAppJsApi.EventStatistics.recordEvent("A13319_全局_游戏工具", "无畏契约战绩查询", 0);
                        GSAppJsApi.UMeng.recordEvent("A13319_全局_游戏工具", "无畏契约战绩查询");
                    }
                    that.IsNeedLogin = true;
                }, 1);
                GSAppJsApi.EventStatistics.recordEvent("Z100010", "", 0);
            };
        }
        GSAppJsApi.UI.sharePage = function() {
            // !!!
            const shareInfo = GSAppJsApi.UI.createShareInfo(
                "renYi",
                "https://image.gamersky.com/zqimg/valorant/image/cover.jpg",
                "无畏契约战绩查询",
                "点击绑定并查询您的战绩信息",
                "https://app.gamersky.com/zt/valorant/valorantWap.html",
                "",
                0,
                () => {}
            );
            GSAppJsApi.UI.share(shareInfo);
            GSAppJsApi.EventStatistics.recordEvent("Z100029", "", 0);

            // !!!
            return "yiFenXiang";
        };
        GSAppJsApi.UI.registerNotificationListener("gamersky.app.shareButtonClicked", function(response) {
            if (response.title == "无畏契约战绩查询") {
                GSAppJsApi.EventStatistics.recordEvent("Z100029", "首页", 0);
                GSAppJsApi.EventStatistics.recordEvent("Z200448", "", 0);
            }
        });
        GSAppJsApi.UI.registerNotificationListener("riotgames-privacy-consent-cancelled", function() {
            that.authPollingLog("cancel_signal_received", {
                requestId: that.pendingAuthorizationBindParams && that.pendingAuthorizationBindParams.requestId,
            });
            that.NoNeedBind = true;
            that.cancelAuthorizationPolling(true);
            that.loading = false;
            that.needLogin = true;
        });
        if (shopLoginReturned) this.resumeShopLoginReturn();
    },
    beforeDestroy() {
        this.cancelQuickBind();
        window.removeEventListener("pagehide", this.cancelRiotEntry);
        this.riotBindRequestGate.invalidate();
        window.removeEventListener("scroll", this.scroll);
        window.removeEventListener("pageshow", this.restoreShopLoginPage);
        this.cancelAuthorizationPolling(true);
        this.clearRefreshCooldownTimer();
        this.clearLoadingDelayTimer();
        this.bindInfoRequestGate.invalidate();
        this.userDataRequestGate.invalidate();
    },
    methods: {
        formatDisplayValue,
        formatPlayTime,
        cancelRiotEntry() {
            this.cancelQuickBind();
            if (this.riotDirectLoginRequest !== null) {
                this.riotBindRequestGate.invalidate();
                this.userDataRequestGate.invalidate();
                this.riotDirectLoginRequest = null;
                this.riotBinding = false;
                this.isFreshing = false;
                this.loading = false;
            }
        },
        cancelQuickBind() {
            this.quickBindGate.invalidate();
            this.quickBindBusy = false;
            this.quickBindLoading = false;
            this.quickBindOpen = false;
            this.quickBindLast = null;
        },
        setQuickBindOpen(open) {
            if (!open && !this.quickBindBusy) this.cancelQuickBind();
        },
        async onOfficialLogin() {
            if (!this.riotQuickBindEnabled) return this.openShopLoginPage();
            if (this.loading || this.riotBinding || this.binding || this.authorizationPolling || this.quickBindOpen || this.quickBindLoading) return false;
            this.quickBindAccounts = [];
            this.quickBindLast = null;
            this.quickBindProgress = { completed: 0, total: 0 };
            return this.loadQuickBindAccounts(true);
        },
        async loadQuickBindAccounts(openWhenLoaded = false) {
            if (!this.riotQuickBindEnabled || (!openWhenLoaded && !this.quickBindOpen) || this.quickBindBusy || this.quickBindLoading) return false;
            if (this.quickBindLast) return this.finishQuickBind();
            const requestId = this.quickBindGate.begin();
            let userId = 0;
            const isCurrent = () => (openWhenLoaded || this.quickBindOpen) && this.quickBindGate.isCurrent(requestId)
                && (!userId || currentGamerskyUserId() === userId);
            this.quickBindLoading = true;
            this.quickBindError = "";
            try {
                userId = Number(await this.ensureGamerskyLogin());
                if (!isCurrent()) return false;
                if (!userId) { this.cancelQuickBind(); return false; }
                this.gamerskyUserId = userId;
                this.quickBindUserId = userId;
                const response = await withTimeout(inquiryApi.getRiotShopAccounts({ gamerskyUserId: userId }), 15000);
                if (!isCurrent()) return false;
                const accounts = normalizeShopAccounts(response);
                const bindings = await withTimeout(inquiryApi.getBindAccountList({ gamerskyUserId: userId }), 15000);
                if (!isCurrent()) return false;
                if (!bindings || bindings.error || !Array.isArray(bindings.bindAccountList)) throw new Error("RIOT_QUICK_LIST_FAILED");
                this.quickBindBindings = bindings.bindAccountList;
                this.quickBindAccounts = accounts.filter(account =>
                    readSharedSession(window.localStorage, userId, account.puuid));
                if (!this.quickBindAccounts.length) return this.quickBindLogin();
                this.quickBindOpen = true;
                return true;
            } catch (error) {
                if (isCurrent()) {
                    this.quickBindError = "账号列表加载失败，请重试";
                    this.quickBindOpen = true;
                }
                return false;
            } finally {
                if (this.quickBindGate.isCurrent(requestId)) {
                    this.quickBindLoading = false;
                    if (userId && currentGamerskyUserId() !== userId) this.cancelQuickBind();
                }
            }
        },
        async quickBindLogin() {
            if (!this.riotQuickBindEnabled || this.quickBindBusy) return false;
            this.cancelQuickBind();
            return this.openShopLoginPage();
        },
        async startQuickBind(selected) {
            if (!this.riotQuickBindEnabled || !this.quickBindOpen || this.quickBindBusy || this.quickBindLoading
                || !Array.isArray(selected) || !selected.length) return false;
            const userId = this.quickBindUserId;
            const requestId = this.quickBindGate.begin();
            const isCurrent = () => this.quickBindGate.isCurrent(requestId) && this.quickBindOpen
                && currentGamerskyUserId() === userId && Number(this.gamerskyUserId) === userId;
            if (!userId || !isCurrent()) { this.cancelQuickBind(); return false; }
            this.quickBindBusy = true;
            this.quickBindError = "";
            this.quickBindLast = null;
            const operationStartedAt = Date.now();
            try {
                const process = createQuickBindProcessor({
                    api: inquiryApi, storage: window.localStorage, userId,
                    bindings: this.quickBindBindings, isCurrent,
                    traceId: () => createTraceId("riot-quick-bind"),
                    onStage: (traceId, stage, details) => reportRiotMonitorEvent(inquiryApi, {
                        traceId, stage, userId, scene: "bind", triggerType: "BIND", ...details,
                    }),
                    prepare: (params, guard) => {
                        if (!config.riotClientFetchEnabled) throw new Error("RIOT_CLIENT_RAW_UNAVAILABLE");
                        return prepareClientRequest(inquiryApi, GSAppJsApi, params, { isCurrent: guard });
                    },
                    renew: (session, guard) => session.loginMode === "VShopMode"
                        ? renewRiotSessionWithVShopWebView(GSAppJsApi, window.localStorage, session.puuid, {
                            isCurrent: guard, scriptUrl: getRiotVShopBridgeScriptUrl(window.location.href),
                        })
                        : renewRiotSessionWithCookie(GSAppJsApi, window.localStorage, session.puuid, undefined, guard),
                    publish: (session, guard) => this.publishRiotSharedSession(session, userId, operationStartedAt, guard),
                });
                const result = await runQuickBindBatch({ accounts: this.quickBindAccounts,
                    selectedPuuids: selected.map(account => account.puuid), isCurrent, process,
                    onProgress: progress => { this.quickBindProgress = progress; },
                });
                if (!isCurrent() || result.cancelled) return false;
                if (!result.last) {
                    this.quickBindError = quickBindFailureMessage(result);
                    return false;
                }
                this.quickBindLast = { response: result.last.response, userId,
                    succeeded: result.successes.length, failed: result.failures.length, pending: result.pending.length };
            } catch (error) {
                if (isCurrent()) this.quickBindError = "绑定未完成，请重试";
                return false;
            } finally {
                if (this.quickBindGate.isCurrent(requestId)) {
                    this.quickBindBusy = false;
                    if (currentGamerskyUserId() !== userId) this.cancelQuickBind();
                }
            }
            return this.finishQuickBind();
        },
        async finishQuickBind() {
            const last = this.quickBindLast;
            if (!last || this.quickBindBusy || !this.quickBindOpen) return false;
            const requestId = this.quickBindGate.current();
            const isCurrent = () => this.quickBindGate.isCurrent(requestId) && this.quickBindOpen
                && currentGamerskyUserId() === last.userId && Number(this.gamerskyUserId) === last.userId;
            if (!isCurrent()) { this.cancelQuickBind(); return false; }
            this.quickBindBusy = true;
            try {
                const response = last.response;
                let operation;
                try {
                    operation = await withTimeout(inquiryApi.prepareActiveAccountOperation({
                        gamerskyUserId: last.userId,
                    }), 15000);
                } catch (_) {
                    throw new Error("RIOT_QUICK_SELECT_PREPARE_FAILED");
                }
                if (!isCurrent()) return false;
                const operationToken = operation && operation.data && operation.data.operationToken;
                if ((operation && operation.error) || !operationToken) throw new Error("RIOT_QUICK_SELECT_PREPARE_FAILED");
                const selected = await withTimeout(inquiryApi.changeActiveAccount({
                    ...buildBindingSelection(last.userId, response),
                    operationToken,
                }), 15000);
                if (!isCurrent()) return false;
                if (!selected || selected.error || !selected.valorantUserName) throw new Error("RIOT_QUICK_SELECT_FAILED");
                this.bindInfoRequestGate.invalidate();
                this.userDataRequestGate.invalidate();
                this.account = response.valorantUserName;
                this.currentBindInfoId = response.bindInfoId;
                this.currentDataSource = "RIOT_PD";
                this.currentSourceLabel = response.sourceLabel || "Riot";
                this.currentSourceAccountId = response.sourceAccountId;
                this.riotAccountSession = null;
                this.selectModes = "";
                this.selectSeasons = "";
                this.riotSessionRecoveryAttempt = 0;
                this.adoptCurrentRiotSharedSession();
                this.applyRefreshState(response);
                this.applyRiotStats(response.riotStats);
                this.needLogin = false;
                this.loading = false;
                this.loadError = false;
                this.loadedValorantTrackerInfo = true;
                this.quickBindOpen = false;
                this.quickBindLast = null;
                this.getBindAccountList();
                if (last.failed || last.pending) this.$toast({ message: `成功 ${last.succeeded} 个，失败 ${last.failed} 个`
                    + (last.pending ? `，待确认 ${last.pending} 个` : "") });
                return true;
            } catch (error) {
                if (isCurrent()) this.quickBindError = error && error.message === "RIOT_QUICK_SELECT_PREPARE_FAILED"
                    ? "测试服务尚未更新，请稍后重试"
                    : "账号已绑定，页面加载失败，请重试";
                return false;
            } finally {
                if (this.quickBindGate.isCurrent(requestId)) this.quickBindBusy = false;
            }
        },
        async openDirectRiotLogin(options = {}) {
            if (!this.riotQuickBindEnabled || this.riotBinding || this.binding || this.authorizationPolling) return false;
            const requestId = this.riotBindRequestGate.begin();
            let userId = 0;
            const isCurrent = () => this.riotBindRequestGate.isCurrent(requestId)
                && (!userId || (currentGamerskyUserId() === userId && Number(this.gamerskyUserId) === userId))
                && (options.purpose !== "refresh" || (this.currentDataSource === "RIOT_PD"
                    && String(this.currentBindInfoId) === String(options.bindInfoId)
                    && this.currentSourceAccountId === options.sourceAccountId));
            const operationStartedAt = Date.now();
            let monitor = null;
            this.riotBinding = true;
            this.riotDirectLoginRequest = requestId;
            try {
                userId = Number(await this.ensureGamerskyLogin());
                if (!this.riotBindRequestGate.isCurrent(requestId) || !userId || currentGamerskyUserId() !== userId) return false;
                this.gamerskyUserId = userId;
                if (!isCurrent()) return false;
                const traceId = options.monitorTraceId || createTraceId("riot-login");
                if (options.purpose === "refresh" && (!options.bindInfoId || !options.sourceAccountId)) throw new Error("RIOT_ACCOUNT_MISMATCH");
                monitor = createRiotFlowMonitor(inquiryApi, { traceId, userId, isCurrent,
                    scene: options.purpose === "refresh" ? "refresh" : "bind",
                    triggerType: options.triggerType || (options.purpose === "refresh" ? "MANUAL" : "BIND"),
                });
                monitor.record("FLOW_STARTED");
                monitor.record("LOGIN_CONFIRMED");
                const session = await loginWithShopRiotDialog(GSAppJsApi, {
                    isCurrent, scriptUrl: config.riotLoginScriptUrl,
                    expectedPuuid: options.purpose === "refresh" ? options.sourceAccountId : undefined,
                    onStage: stage => {
                        const stages = { login_window_open: "LOGIN_PAGE_OPENED", login_callback: "LOGIN_CALLBACK_RECEIVED" };
                        if (stages[stage] && isCurrent()) reportRiotMonitorEvent(inquiryApi, {
                            traceId, stage: stages[stage], userId,
                            scene: options.purpose === "refresh" ? "refresh" : "bind",
                            triggerType: options.triggerType || (options.purpose === "refresh" ? "MANUAL" : "BIND"),
                        });
                    },
                });
                if (!isCurrent()) return false;
                this.riotBinding = false;
                return options.purpose === "refresh"
                    ? await this.resumeRiotRefresh({ ...options, session, userId, operationStartedAt, monitorTraceId: traceId }, isCurrent)
                    : await this.bindRiotAccount(session, userId, traceId, operationStartedAt);
            } catch (error) {
                if (!isCurrent()) return false;
                if (monitor) monitor.record("FLOW_FINISHED", { success: false,
                    failType: /^RIOT_[A-Z_]+$/.test(error.message || "") ? error.message : "RIOT_LOGIN_FAILED" });
                const messages = { RIOT_ACCOUNT_MISMATCH: "拳头账号与当前选择不一致", RIOT_LOGIN_CANCELLED: "已取消登录",
                    RIOT_LOGIN_TIMEOUT: "登录超时，请重试", RIOT_LOGIN_UNSUPPORTED: "当前客户端不支持，请更新客户端" };
                this.$toast({ type: "error", message: messages[error.message] || "登录未完成，请重试" });
                return false;
            } finally {
                if (this.riotBindRequestGate.isCurrent(requestId)) this.riotBinding = false;
                if (this.riotDirectLoginRequest === requestId) this.riotDirectLoginRequest = null;
            }
        },
        currentRiotSharedScope() {
            const userId = currentGamerskyUserId();
            if (!this.isCurrentUser || !Number.isSafeInteger(userId) || userId <= 0
                || userId !== Number(this.gamerskyUserId)
                || this.currentDataSource !== "RIOT_PD" || !this.currentBindInfoId
                || !this.currentSourceAccountId) return null;
            return { userId, puuid: this.currentSourceAccountId };
        },
        publishRiotSharedSession(session, userId, operationStartedAt, isCurrent) {
            if (!session || !session.puuid || !this.isCurrentUser
                || currentGamerskyUserId() !== Number(userId)
                || Number(this.gamerskyUserId) !== Number(userId)
                || (isCurrent && !isCurrent())) return session;
            let storage;
            try { storage = window.localStorage; } catch (error) { return session; }
            const published = publishSharedSession(storage, {
                publisher: "record",
                userId, puuid: session.puuid, session, operationStartedAt, isCurrent: () =>
                    currentGamerskyUserId() === Number(userId)
                    && (!isCurrent || isCurrent()),
            });
            const shared = readSharedSession(storage, userId, session.puuid);
            if (shared && (published || shared.operationStartedAt > operationStartedAt)) {
                if (!published) {
                    try { saveRiotRecordSession(storage, shared); } catch (error) { /* The shared credentials remain usable. */ }
                }
                this.riotSessionOperationStartedAt = shared.operationStartedAt;
                this.riotSharedSessionUpdatedAt = shared.updatedAt;
                return shared;
            }
            this.riotSessionOperationStartedAt = operationStartedAt;
            this.riotSharedSessionUpdatedAt = 0;
            return session;
        },
        adoptCurrentRiotSharedSession() {
            const scope = this.currentRiotSharedScope();
            if (!scope) return null;
            let storage;
            try { storage = window.localStorage; } catch (error) { return null; }
            const shared = readSharedSession(storage, scope.userId, scope.puuid);
            const localMatches = this.riotAccountSession
                && this.riotAccountSession.puuid === scope.puuid;
            const localStartedAt = localMatches ? this.riotSessionOperationStartedAt : 0;
            const localUpdatedAt = localMatches ? this.riotSharedSessionUpdatedAt : 0;
            if (shared) {
                if (!localMatches || shared.operationStartedAt > localStartedAt
                    || (shared.operationStartedAt === localStartedAt && shared.updatedAt > localUpdatedAt)) {
                    try { saveRiotRecordSession(storage, shared); } catch (error) { /* Shared session can still serve the query. */ }
                    this.riotAccountSession = shared;
                    this.riotSessionOperationStartedAt = shared.operationStartedAt;
                    this.riotSharedSessionUpdatedAt = shared.updatedAt;
                }
                return this.riotAccountSession;
            }
            let legacy;
            try { legacy = readRiotAccountSession(storage, scope.puuid, this.riotAccountSession); } catch (error) { return null; }
            const operationStartedAt = 1;
            const migrated = publishSharedSession(storage, {
                ...scope, session: legacy, operationStartedAt, onlyIfAbsent: true,
            });
            if (!migrated) {
                const racedShared = readSharedSession(storage, scope.userId, scope.puuid);
                if (racedShared) {
                    try { saveRiotRecordSession(storage, racedShared); } catch (error) { /* The shared credentials remain usable. */ }
                    this.riotAccountSession = racedShared;
                    this.riotSessionOperationStartedAt = racedShared.operationStartedAt;
                    this.riotSharedSessionUpdatedAt = racedShared.updatedAt;
                    return racedShared;
                }
            }
            this.riotAccountSession = legacy;
            this.riotSessionOperationStartedAt = migrated ? operationStartedAt : 0;
            this.riotSharedSessionUpdatedAt = migrated
                ? ((readSharedSession(storage, scope.userId, scope.puuid) || {}).updatedAt || 0) : 0;
            return legacy;
        },
        async ensureGamerskyLogin() {
            let userId = Number(GSAppJsApi.User.getCurrentUserId());
            if (Number.isInteger(userId) && userId > 0) return userId;
            const loggedIn = await withTimeout(new Promise((resolve) => GSAppJsApi.User.loginTo(resolve)), 600000);
            if (!loggedIn) return 0;
            userId = Number(GSAppJsApi.User.getCurrentUserId());
            return Number.isInteger(userId) && userId > 0 ? userId : 0;
        },
        openTrackerBindingForm() {
            if (!this.loading && !this.riotBinding && !this.binding && !this.authorizationPolling) this.trackerBindingFormOpen = true;
        },
        submitTrackerBinding() {
            if (!this.loading && !this.riotBinding && !this.binding && !this.authorizationPolling) this.bind();
        },
        async openShopLoginPage(options = {}) {
            if (this.riotQuickBindEnabled) return this.openDirectRiotLogin(options);
            if (!this.riotBindingPageEnabled || !config.riotShopLoginUrl || this.loading || this.riotBinding || this.binding || this.authorizationPolling) return false;
            const requestId = this.riotBindRequestGate.begin();
            const isCurrent = () => this.riotBindRequestGate.isCurrent(requestId);
            this.riotBinding = true;
            this.loading = true;
            try {
                const userId = await this.ensureGamerskyLogin();
                if (!isCurrent()) return false;
                if (!userId) {
                    this.riotBinding = false;
                    this.loading = false;
                    return false;
                }
                this.gamerskyUserId = userId;
                const flow = createShopRecordLogin(
                    window.localStorage,
                    window.location.href,
                    config.riotShopLoginUrl,
                    this.gamerskyUserId,
                    {
                        purpose: options.purpose,
                        bindInfoId: options.bindInfoId,
                        sourceAccountId: options.sourceAccountId,
                        recoveryAttempt: options.recoveryAttempt,
                        loginMode: options.loginMode,
                        monitorUrl: config.baseUrl + "/valorantTracker/riot/stats/event",
                        monitorTraceId: options.monitorTraceId,
                    }
                );
                this.pendingShopLoginId = flow.id;
                const monitor = createRiotFlowMonitor(inquiryApi, {
                    traceId: options.monitorTraceId || flow.id,
                    scene: options.purpose === "refresh" ? "refresh" : "bind",
                    triggerType: options.purpose === "refresh"
                        ? (options.triggerType || "MANUAL") : "BIND",
                    userId: this.gamerskyUserId,
                });
                monitor.record("FLOW_STARTED");
                monitor.record("LOGIN_CONFIRMED");
                window.location.assign(flow.loginUrl);
                return true;
            } catch (error) {
                if (!isCurrent()) return false;
                this.restoreShopLoginPage({ persisted: true });
                this.riotBinding = false;
                this.loading = false;
                this.$toast({ type: "error", message: error && error.message === "RIOT_SHOP_LOGIN_ORIGIN"
                    ? "请在测试服页面完成拳头登录" : "拳头登录暂不可用，请重试" });
                return false;
            }
        },
        async resumeShopLoginReturn() {
            if (!this.riotBindingPageEnabled || this.riotBinding) return false;
            const pageUrl = window.location.href;
            const cleanUrl = new URL(pageUrl);
            if (!cleanUrl.searchParams.has("valorantRecordLogin")) return false;
            const loginId = cleanUrl.searchParams.get("valorantRecordLogin") || "";
            cleanUrl.searchParams.delete("valorantRecordLogin");
            try { window.history.replaceState(null, "", cleanUrl.href); } catch (error) { /* The one-time storage receipt also prevents replay. */ }
            const requestId = this.riotBindRequestGate.begin();
            const isCurrent = () => this.riotBindRequestGate.isCurrent(requestId);
            this.riotBinding = true;
            this.loading = true;
            let returnUserId = 0;
            try {
                returnUserId = await this.ensureGamerskyLogin();
                if (!isCurrent()) return false;
                if (!returnUserId) throw new Error("RIOT_LOGIN_CANCELLED");
                const result = consumeShopRecordLogin(window.localStorage, pageUrl, returnUserId);
                reportRiotMonitorEvent(inquiryApi, {
                    traceId: result.monitorTraceId || result.id,
                    stage: "LOGIN_CALLBACK_RECEIVED",
                    userId: result.userId,
                    scene: result.purpose,
                    triggerType: result.triggerType || (result.purpose === "refresh" ? "MANUAL" : "BIND"),
                });
                this.riotBinding = false;
                let succeeded = false;
                try {
                    succeeded = result.purpose === "refresh"
                        ? await this.resumeRiotRefresh(result, isCurrent)
                        : await this.bindRiotAccount(
                            result.session, result.userId, result.monitorTraceId || result.id,
                            result.operationStartedAt
                        );
                } catch (error) {
                    completeShopRecordLoginOutcome(window.localStorage, result.id, result.userId, false, {
                        error: error && error.message,
                    });
                    throw error;
                }
                completeShopRecordLoginOutcome(window.localStorage, result.id, result.userId, Boolean(succeeded), {
                    bindInfoId: this.currentBindInfoId,
                    sourceAccountId: this.currentSourceAccountId,
                    error: succeeded ? "" : "RIOT_LOGIN_RETURN_FAILED",
                });
                return succeeded;
            } catch (error) {
                if (!isCurrent()) return false;
                const repeatedResult = await this.resumeRepeatedShopLoginReturn(loginId, returnUserId, isCurrent);
                if (repeatedResult !== null) return repeatedResult;
                try { cancelShopRecordLogin(window.localStorage, loginId); } catch (storageError) { /* Do not cancel another login attempt. */ }
                this.riotBinding = false;
                this.loading = false;
                this.needLogin = true;
                this.$toast({ type: "error", message: "登录回传已失效，请重新登录" });
                return false;
            } finally {
                if (isCurrent()) {
                    this.riotBinding = false;
                    this.loading = false;
                }
            }
        },
        async resumeRepeatedShopLoginReturn(loginId, returnUserId, isCurrent) {
            if (!loginId || !returnUserId) return null;
            const deadline = Date.now() + RIOT_DATA_REQUEST_TIMEOUT_MS + 5000;
            let outcome = null;
            try {
                outcome = readShopRecordLoginOutcome(window.localStorage, loginId, returnUserId);
                while (outcome && outcome.state === "processing" && isCurrent() && Date.now() < deadline) {
                    await new Promise((resolve) => setTimeout(resolve, 250));
                    outcome = readShopRecordLoginOutcome(window.localStorage, loginId, returnUserId);
                }
            } catch (error) {
                return null;
            }
            if (!isCurrent() || !outcome) return null;
            this.riotBinding = false;
            if (outcome.state === "succeeded") {
                this.loading = true;
                this.needLogin = false;
                this.getBindAccountList();
                return Boolean(await this.getBindInfo());
            }
            if (outcome.state === "failed") {
                this.loading = false;
                this.needLogin = true;
                this.$toast({ type: "error", message: "Riot账号绑定失败，请重新登录后重试" });
                return false;
            }
            return null;
        },
        async resumeRiotRefresh(result, isCurrent) {
            if (!result || !result.session || !result.bindInfoId || !result.sourceAccountId
                || result.session.puuid !== result.sourceAccountId
                || currentGamerskyUserId() !== Number(result.userId)
                || (isCurrent && !isCurrent())) {
                throw new Error("RIOT_ACCOUNT_MISMATCH");
            }
            saveRiotRecordSession(window.localStorage, result.session);
            const monitor = createRiotFlowMonitor(inquiryApi, {
                traceId: result.monitorTraceId || result.id,
                scene: "refresh",
                triggerType: result.triggerType || "MANUAL",
                userId: result.userId,
            });
            monitor.record("SESSION_SAVED");
            this.riotAccountSession = this.publishRiotSharedSession(
                result.session, result.userId, result.operationStartedAt || Date.now(), isCurrent
            );
            this.riotSessionRecoveryAttempt = Number(result.recoveryAttempt) || 0;
            this.currentBindInfoId = result.bindInfoId;
            this.currentDataSource = "RIOT_PD";
            this.currentSourceLabel = "Riot";
            this.currentSourceAccountId = result.sourceAccountId;
            this.needLogin = false;
            this.loading = true;

            const cacheLoaded = await this.getUserData(false, {
                showLoading: true,
                skipAutoRefresh: true,
            });
            if (!isCurrent()) return false;
            if (!cacheLoaded || !this.canRefresh || this.refreshInProgress) {
                return cacheLoaded;
            }
            this.isFreshing = true;
            const succeeded = await this.getUserData(true, {
                showLoading: false,
                monitorTraceId: result.monitorTraceId || result.id,
                triggerType: result.triggerType || "MANUAL",
                postRenew: true,
            });
            if (!isCurrent()) return false;
            monitor.record("POST_RENEW_QUERY_FINISHED", {
                success: Boolean(succeeded),
                failType: succeeded ? "" : "RIOT_STATS_FAILED",
            });
            monitor.record("FLOW_FINISHED", {
                success: Boolean(succeeded),
                failType: succeeded ? "" : "RIOT_STATS_FAILED",
            });
            return succeeded;
        },
        startRiotAutoRefresh(expectedBindInfoId, expectedSourceAccountId) {
            if (this.currentDataSource !== "RIOT_PD"
                || this.currentBindInfoId !== expectedBindInfoId
                || this.currentSourceAccountId !== expectedSourceAccountId) {
                return Promise.resolve(false);
            }
            this.isFreshing = true;
            return Promise.resolve(this.getUserData(false, {
                autoRefresh: true,
                preserveCurrentData: true,
                silentFailure: true,
            })).finally(() => {
                if (this.currentDataSource === "RIOT_PD"
                    && this.currentBindInfoId === expectedBindInfoId
                    && this.currentSourceAccountId === expectedSourceAccountId) {
                    this.isFreshing = false;
                }
            });
        },
        async recoverRiotSessionAndRetry(isFresh, options = {}) {
            this.adoptCurrentRiotSharedSession();
            const operationStartedAt = Date.now();
            const shouldShowRefreshing = isFresh || options.autoRefresh === true;
            const skipSilentRenewal = options.skipSilentRenewal === true;
            const monitor = createRiotFlowMonitor(inquiryApi, {
                traceId: options.monitorTraceId,
                scene: "refresh",
                triggerType: options.triggerType || (options.autoRefresh === true ? "AUTO" : "MANUAL"),
                getUserId: () => this.gamerskyUserId,
            });
            if (this.riotSessionRecoveryAttempt >= 1 && !skipSilentRenewal) {
                monitor.record("FLOW_FINISHED", { success: false, failType: "RIOT_RENEW_UNAVAILABLE" });
                this.loading = false;
                this.isFreshing = false;
                this.$toast({ type: "error", message: "更新暂未完成，请稍后重试" });
                return false;
            }
            this.riotSessionRecoveryAttempt = 1;
            if (shouldShowRefreshing) this.isFreshing = true;
            const recoveryLoginMode = this.riotAccountSession
                && this.riotAccountSession.loginMode === "VShopMode" ? "VShopMode" : "ApiMode";
            const expectedBindInfoId = this.currentBindInfoId;
            const expectedSourceAccountId = this.currentSourceAccountId;
            const expectedUserId = Number(this.gamerskyUserId);
            let originalSession = null;
            try { originalSession = readRiotAccountSession(window.localStorage, expectedSourceAccountId, this.riotAccountSession); }
            catch (_) { /* Missing credentials use the existing interactive recovery below. */ }
            const recoveryRequestId = this.userDataRequestGate.current();
            const isCurrent = () => this.userDataRequestGate.isCurrent(recoveryRequestId)
                && currentGamerskyUserId() === expectedUserId && Number(this.gamerskyUserId) === expectedUserId
                && this.currentDataSource === "RIOT_PD"
                && this.currentBindInfoId === expectedBindInfoId
                && this.currentSourceAccountId === expectedSourceAccountId;
            try {
                if (!options.renewalFlowStarted) monitor.record("FLOW_STARTED");
                if (skipSilentRenewal) {
                    if (!options.renewalFallback) monitor.record("POST_RENEW_QUERY_FINISHED", {
                        success: false,
                        failType: "RIOT_SESSION_EXPIRED",
                    });
                    throw new Error("RIOT_SESSION_EXPIRED");
                }
                monitor.record("SILENT_RENEW_STARTED");
                const session = recoveryLoginMode === "VShopMode"
                    ? await renewRiotSessionWithVShopWebView(
                        GSAppJsApi,
                        window.localStorage,
                        expectedSourceAccountId,
                        {
                            isCurrent,
                            scriptUrl: getRiotVShopBridgeScriptUrl(window.location.href),
                        }
                    )
                    : await renewRiotSessionWithCookie(
                        GSAppJsApi,
                        window.localStorage,
                        expectedSourceAccountId,
                        undefined,
                        isCurrent
                    );
                if (!isCurrent()) return false;
                this.riotAccountSession = this.publishRiotSharedSession(
                    session, this.gamerskyUserId, operationStartedAt, isCurrent
                );
                monitor.record("SILENT_RENEW_SUCCEEDED", { success: true });
                const succeeded = await this.getUserData(isFresh, {
                    ...options,
                    monitorTraceId: monitor.traceId,
                    showLoading: false,
                    delayLoading: false,
                    postRenew: true,
                    sessionRenewed: true,
                    renewalFlowStarted: true,
                });
                monitor.record("POST_RENEW_QUERY_FINISHED", {
                    success: Boolean(succeeded),
                    failType: succeeded ? "" : "RIOT_STATS_FAILED",
                });
                monitor.record("FLOW_FINISHED", {
                    success: Boolean(succeeded),
                    failType: succeeded ? "" : "RIOT_STATS_FAILED",
                });
                return succeeded;
            } catch (error) {
                if (!isCurrent() || (error && error.message === "RIOT_LOGIN_OBSOLETE")) return false;
                if (!skipSilentRenewal) {
                    monitor.record("SILENT_RENEW_FAILED", {
                        success: false,
                        failType: error && error.message,
                    });
                }
                const errorCode = error && (error.code || error.message);
                const transientRenewal = isRiotRenewalTemporaryFailure(error) || errorCode === "RIOT_ACCOUNT_MISMATCH";
                if (!skipSilentRenewal && transientRenewal && originalSession) {
                    this.riotAccountSession = originalSession;
                    const fallback = { loginRequired: false, renewalUnconfirmed: true };
                    const succeeded = await this.getUserData(isFresh, {
                        ...options, monitorTraceId: monitor.traceId, showLoading: false, delayLoading: false,
                        renewalFlowStarted: true, renewalFallback: fallback,
                    });
                    // Expired credentials delegate to the existing login prompt, not another renewal.
                    if (!fallback.loginRequired) monitor.record("FLOW_FINISHED", {
                        success: Boolean(succeeded), failType: succeeded ? "" : "RIOT_STATS_FAILED",
                    });
                    return succeeded;
                }
                this.loading = false;
                this.isFreshing = false;
                this.binding = false;
                const loginRequired = skipSilentRenewal || !originalSession || isRiotRenewalLoginRequired(error);
                if (!loginRequired) {
                    monitor.record("FLOW_FINISHED", { success: false, failType: errorCode });
                    if (!options.silentFailure) this.$toast({ type: "error", message: "更新失败，请稍后重试" });
                    return false;
                }
                monitor.record("RELOGIN_DIALOG_SHOWN");
                try {
                    await showAuthModal({
                        contentLines: ["Riot登录已失效，请重新登录后更新战绩"],
                        confirmText: "去登录",
                        cancelText: "取消",
                    });
                } catch (cancelled) {
                    monitor.record("RELOGIN_CANCELLED", { success: false, failType: "RIOT_LOGIN_CANCELLED" });
                    monitor.record("FLOW_FINISHED", { success: false, failType: "RIOT_LOGIN_CANCELLED" });
                    return false;
                }
                if (!isCurrent()) return false;
                monitor.record("RELOGIN_CONFIRMED");
                const opened = await this.openShopLoginPage({
                    purpose: "refresh",
                    bindInfoId: expectedBindInfoId,
                    sourceAccountId: expectedSourceAccountId,
                    recoveryAttempt: 1,
                    loginMode: recoveryLoginMode,
                    monitorTraceId: monitor.traceId,
                    triggerType: options.triggerType || (options.autoRefresh === true ? "AUTO" : "MANUAL"),
                });
                if (!opened) {
                    monitor.record("FLOW_FINISHED", { success: false, failType: "RIOT_LOGIN_UNSUPPORTED" });
                    this.$toast({ type: "error", message: "Riot登录已失效，请重新登录" });
                }
                // Opening the login page only starts recovery. This refresh succeeds only
                // after the returned credentials complete a new stats query.
                return false;
            }
        },
        async recoverCompletedRiotRefresh(requestId, refreshStartedAt, previousRefreshTime) {
            const waitMs = Math.min(30000, RIOT_REFRESH_COMPLETION_WAIT_MS);
            const deadline = Date.now() + waitMs;
            const previous = Number(previousRefreshTime) || 0;
            console.warn("[ValorantRiotRefresh] waiting for background completion", {
                requestId,
                elapsedMs: Date.now() - refreshStartedAt,
                deadlineMs: waitMs,
            });
            while (this.userDataRequestGate.isCurrent(requestId) && Date.now() < deadline) {
                try {
                    const res = await withTimeout(inquiryApi.getRiotStats({ ...buildRiotQueryRequest(
                        this.gamerskyUserId,
                        this.currentBindInfoId,
                        this.currentSourceAccountId,
                        null,
                        false,
                        false,
                        normalizeModeCode(this.selectModes) || "all",
                        this.selectSeasons
                    ), clientFetch: config.riotClientFetchEnabled === true }), 5000);
                    if (!this.userDataRequestGate.isCurrent(requestId)) return false;
                    const refreshedAt = Number(res && res.lastRefreshTime) || 0;
                    const completedAfterRequest = previous > 0
                        ? refreshedAt > previous
                        : refreshedAt >= refreshStartedAt - 5000;
                    const trackerInfo = res && res.riotStats && res.riotStats.view;
                    if (!res.error && trackerInfo && completedAfterRequest) {
                        this.applyRefreshState(res);
                        this.currentBindInfoId = res.bindInfoId || this.currentBindInfoId;
                        this.account = res.valorantUserName || this.account;
                        this.currentSourceAccountId = res.sourceAccountId || this.currentSourceAccountId;
                        this.applyRiotStats(res.riotStats);
                        this.loadedValorantTrackerInfo = true;
                        this.riotSessionRecoveryAttempt = 0;
                        this.binding = false;
                        this.loading = false;
                        this.isFreshing = false;
                        GSAppJsApi.EventStatistics.recordEvent("Z200447", "", 0);
                        console.info("[ValorantRiotRefresh] recovered completed refresh", {
                            requestId,
                            elapsedMs: Date.now() - refreshStartedAt,
                        });
                        return true;
                    }
                } catch (error) {
                    // The original refresh may still be completing behind the gateway.
                }
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }
            console.warn("[ValorantRiotRefresh] background completion not observed", {
                requestId,
                elapsedMs: Date.now() - refreshStartedAt,
            });
            return false;
        },
        restoreShopLoginPage(event) {
            if (!event.persisted || !this.pendingShopLoginId) return;
            let returnedId = "";
            try { returnedId = new URL(window.location.href).searchParams.get("valorantRecordLogin") || ""; } catch (error) { /* Treat an invalid URL as a cancelled navigation. */ }
            const completedCurrentLogin = returnedId === this.pendingShopLoginId;
            if (!completedCurrentLogin) {
                try { cancelShopRecordLogin(window.localStorage, this.pendingShopLoginId); } catch (error) { /* Release the local UI even when storage is unavailable. */ }
            }
            this.pendingShopLoginId = "";
            this.riotBinding = false;
            this.loading = false;
            if (completedCurrentLogin) window.location.reload();
        },
        selectRiotDiagnosticLog() {
            const area = this.$refs && this.$refs.riotDiagnosticLog;
            if (area) {
                area.focus();
                area.select();
            }
        },
        clearLoadingDelayTimer() {
            if (this.loadingDelayTimer) {
                clearTimeout(this.loadingDelayTimer);
                this.loadingDelayTimer = null;
            }
        },
        scheduleLoadingDelay(requestId) {
            this.clearLoadingDelayTimer();
            this.loadingDelayTimer = setTimeout(() => {
                this.loadingDelayTimer = null;
                if (this.userDataRequestGate.isCurrent(requestId)) {
                    this.loading = true;
                    this.loadError = false;
                }
            }, 800);
        },
        clearRefreshCooldownTimer() {
            if (this.refreshCooldownTimer) {
                clearTimeout(this.refreshCooldownTimer);
                this.refreshCooldownTimer = null;
            }
        },
        applyRefreshState(response) {
            this.clearRefreshCooldownTimer();
            this.refreshInProgress = response && response.refreshInProgress === true;
            this.canRefresh = !response || response.canRefresh !== false;
            this.nextRefreshTime = response && response.nextRefreshTime
                ? Number(response.nextRefreshTime)
                : null;
            this.lastRefreshTime = response && response.lastRefreshTime
                ? Number(response.lastRefreshTime)
                : null;

            if (!this.canRefresh && this.nextRefreshTime) {
                const fallbackCooldown = (this.currentDataSource === "RIOT_PD" ? 30 : 60) * 60 * 1000;
                const responseCooldown = this.lastRefreshTime
                    ? this.nextRefreshTime - this.lastRefreshTime : 0;
                const fullCooldown = Number.isFinite(responseCooldown) && responseCooldown > 0
                    ? Math.min(responseCooldown, fallbackCooldown) : fallbackCooldown;
                const clientRemaining = this.nextRefreshTime - Date.now();
                // A skewed phone clock must not override an explicit server cooldown.
                const remaining = Number.isFinite(clientRemaining) && clientRemaining > 0
                    ? Math.min(clientRemaining, fullCooldown) : fullCooldown;
                this.refreshCooldownTimer = setTimeout(() => {
                    this.canRefresh = true;
                    this.refreshInProgress = false;
                    this.nextRefreshTime = null;
                    this.refreshCooldownTimer = null;
                }, remaining + 100);
            }
        },
        changeAccountOption(account) {
            if (this.accountSwitching) {
                return;
            }
            if (this.isAccountActive(account)) {
                this.changeAccountModel = false;
                return;
            }

            const params = buildBindingSelection(this.gamerskyUserId, account);
            this.accountSwitching = true;
            this.changeAccountModel = false;
            this.loading = true;
            this.loadError = false;
            this.isFreshing = false;
            this.riotSessionRecoveryAttempt = 0;
            this.clearLoadingDelayTimer();
            this.bindInfoRequestGate.invalidate();
            this.userDataRequestGate.invalidate();

            return withTimeout(inquiryApi.changeActiveAccount(params), 15000)
                .then((res) => {
                    if (res.error || !res.valorantUserName) {
                        throw new Error((res.error && res.error.message) || "切换账号失败");
                    }

                    this.account = res.valorantUserName;
                    this.currentBindInfoId = res.bindInfoId || account.bindInfoId || null;
                    this.currentDataSource = normalizeSource(res.dataSource || account.dataSource);
                    this.currentSourceLabel = res.sourceLabel || account.sourceLabel || "Tracker";
                    this.currentSourceAccountId = res.sourceAccountId || account.sourceAccountId || "";
                    this.riotStatsSnapshot = null;
                    this.selectModes = "";
                    this.selectSeasons = "";
                    this.needLogin = false;
                    return this.getUserData(false, { showLoading: true });
                })
                .catch(() => {
                    this.loading = false;
                    this.isFreshing = false;
                    this.$toast({
                        type: "error",
                        message: "切换账号失败，请重试",
                    });
                    return false;
                })
                .then((result) => {
                    this.accountSwitching = false;
                    return result;
                });
        },
        removeBoundAccount(account) {
            if (this.accountSwitching || this.accountRemovingKey || !account) {
                return false;
            }

            const removingKey = accountKey(account);
            const removingActive = this.isAccountActive(account);
            const params = buildBindingSelection(this.gamerskyUserId, account);
            this.accountRemovingKey = removingKey;

            return withTimeout(inquiryApi.unBindAccount(params), 15000)
                .then((res) => {
                    if (res && res.error) {
                        throw new Error((res.error && res.error.message) || "解绑失败");
                    }

                    this.changeAccountList = this.changeAccountList.filter((item) => accountKey(item) !== removingKey);
                    this.$toast({ type: "success", message: "解绑成功" });

                    if (removingActive) {
                        this.changeAccountModel = false;
                        this.valorantTrackerInfo = null;
                        this.riotStatsSnapshot = null;
                        this.loading = true;
                        return this.getBindInfo();
                    }
                    return true;
                })
                .catch(() => {
                    this.$toast({ type: "error", message: "解绑失败，请重试" });
                    return false;
                })
                .then((result) => {
                    if (this.accountRemovingKey === removingKey) this.accountRemovingKey = "";
                    return result;
                });
        },
        accountKey(account) {
            return accountKey(account);
        },
        isAccountActive(account) {
            return isAccountActive(
                account,
                this.currentBindInfoId,
                this.account,
                this.currentDataSource
            );
        },
        record(type, gsUserId) {
            var params = {
                siteName: "01",
                type: type,
                gsUserId: gsUserId,
                errorInfo: "",
            };
            inquiryApi.reportStatus(params);
        },
        getBindAccountList() {
            if (!this.gamerskyUserId) {
                this.needLogin = true;
                this.loading = false;
                return false;
            }
            const bindInfo = {
                gamerskyUserId: this.gamerskyUserId,
            };
            inquiryApi
                .getBindAccountList(bindInfo)
                .then((res) => {
                    if (!res.error && res.bindAccountList) {
                        this.changeAccountList = res.bindAccountList.map((account) => ({
                            ...account,
                            dataSource: normalizeSource(account.dataSource),
                            sourceLabel: account.sourceLabel || "Tracker",
                            sourceAccountId: account.sourceAccountId || "",
                        }));
                    }

                    console.log(this.changeAccountList);
                })
                .catch(() => {});
        },
        toList() {
            // var a = document.createElement("a");
            // a.href = `./recordList.html?&appNavigationBarStyle=kNoneBar`;
            // a.target = "_blank";
            // a.click()

            let url = this.$utils.getCurrentUrl() + "recordList.html";
            let params = {
                dataSource: this.currentDataSource,
                bindInfoId: this.currentBindInfoId || "",
                sourceAccountId: this.currentSourceAccountId || "",
                headImageUrl: this.valorantTrackerInfo.headImageUrl || "",
                level: this.valorantTrackerInfo.level === null || this.valorantTrackerInfo.level === undefined
                    ? "" : this.valorantTrackerInfo.level,
            };
            if (!this.isCurrentUser) {
                params.gsAppChannelParams = this.gamerskyUserId;
            }
            this.$utils.openWithNewWindow(url, params);
        },
        ToDetail(e) {
            var that = this;
            if (this.currentDataSource === "TRACKER" && e.mode == "deathmatch") {
                that.$toast({
                    type: "error",
                    message: "该比赛类型暂时无法查看详情",
                    time: 2000,
                });
                return;
            }
            this.$utils.openWithNewWindow(this.$utils.getCurrentUrl() + "recordDetails.html", {
                matchId: encodeURIComponent(e.trackerId),
                mode: encodeURIComponent(e.mode),
                season: encodeURIComponent(e.season),
                userName: encodeURIComponent(e.valorantUserName || this.account),
                dataSource: this.currentDataSource,
                bindInfoId: this.currentBindInfoId || "",
                sourceAccountId: this.currentSourceAccountId || "",
                headImageUrl: this.valorantTrackerInfo.headImageUrl || "",
                level: this.valorantTrackerInfo.level === null || this.valorantTrackerInfo.level === undefined
                    ? "" : this.valorantTrackerInfo.level,
                ...(this.isCurrentUser ? {} : { gsAppChannelParams: this.gamerskyUserId }),
            });
        },
        getTimeDiff(timestamp1, timestamp2) {
            // 将时间戳转换为毫秒数
            var diffInMilliseconds = Math.abs(timestamp2 - timestamp1);

            // 计算时间差的分钟数
            var diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

            // 根据分钟数返回相应的时间间隔文本
            if (diffInMinutes <= 0) {
                return "1分钟以内";
            } else if (diffInMinutes < 60) {
                return diffInMinutes + "分钟前";
            } else if (diffInMinutes < 1440) {
                return Math.floor(diffInMinutes / 60) + "小时前";
            } else {
                return Math.floor(diffInMinutes / 1440) + "天前";
            }
        },

        calcRate(type) {
            const wins = Number(this.valorantTrackerInfo.allWins);
            const losses = Number(this.valorantTrackerInfo.allLose);
            const total = wins + losses;
            if (!Number.isFinite(wins) || !Number.isFinite(losses) || total <= 0) return 0;
            return type === "win" ? wins / total : losses / total;
        },

        closepall() {
            this.collapse = !this.collapse;
        },

        isModeActive(modeOption) {
            return normalizeModeCode(this.selectModes) === modeOption.code;
        },

        selectModeOption(modeOption) {
            if (this.currentDataSource === "RIOT_PD" && this.riotStatsSnapshot) {
                const success = this.applyRiotMode(modeOption.code, modeOption.requestValue);
                if (!success) {
                    this.$toast({ type: "error", message: "请先更新Riot战绩数据" });
                }
                return Promise.resolve(success);
            }
            return this.changeRecordScope("selectModes", modeOption.requestValue);
        },

        selectOtherMode() {
            if (!this.otherModeOptions.length) return;
            const buttonInfes = this.otherModeOptions.map((modeOption) => ({
                groupName: modeOption.caption,
                iconUrl: "",
                name: modeOption.caption,
                modeValue: modeOption.requestValue,
                beSelected: this.isModeActive(modeOption),
            }));
            GSAppJsApi.UI.openMenu("anNiu_danXuan", ["其他"], buttonInfes, (event) => {
                const selectedName = event && Array.isArray(event.selectedButtonNames)
                    ? event.selectedButtonNames[0] : "";
                const selectedMode = this.otherModeOptions.find((modeOption) => modeOption.caption === selectedName);
                if (selectedMode) this.selectModeOption(selectedMode);
            });
        },

        // 选择赛季
        selectSeason() {
            let buttonGroupNames = ["赛季"];
            let seasons = this.seasons;
            let buttonInfes = [];
            for (let i = 0; i < seasons.length; i++) {
                buttonInfes.push({
                    groupName: seasons[i].label,
                    iconUrl: "",
                    name: seasons[i].label,
                    beSelected: this.selectSeasons == seasons[i].label ? true : false,
                });
            }
            let that = this;
            GSAppJsApi.UI.openMenu("anNiu_danXuan", buttonGroupNames, buttonInfes, function(e) {
                console.log("e", e);
                that.changeRecordScope("selectSeasons", e.selectedButtonNames[0]);
            });
        },

        changeRecordScope(field, nextValue) {
            if (!nextValue || this[field] === nextValue) return Promise.resolve(true);

            const previousMode = (this.valorantTrackerInfo && this.valorantTrackerInfo.defaultMode) || this.selectModes;
            const previousSeason = (this.valorantTrackerInfo && this.valorantTrackerInfo.passon) || this.selectSeasons;
            this[field] = nextValue;
            const expectedMode = this.selectModes;
            const expectedSeason = this.selectSeasons;

            const request = this.getUserData(false, {
                delayLoading: true,
                preserveCurrentData: true,
            });
            const requestId = this.userDataRequestGate.current();
            return request.then((success) => {
                if (!this.userDataRequestGate.isCurrent(requestId)) return false;
                if (!success && this.selectModes === expectedMode && this.selectSeasons === expectedSeason) {
                    this.selectModes = previousMode;
                    this.selectSeasons = previousSeason;
                }
                return success;
            });
        },

        // 账号是否已绑定
        isAccountBinded() {
            if (this.changeAccountList && this.changeAccountList.length > 0) {
                console.log("changeAccountList", this.changeAccountList);
                if (isTrackerAccountBound(this.changeAccountList, this.account)) {
                    this.$toast({
                        type: "error",
                        message: "该账号已绑定请重新输入",
                    });
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },

        // 绑定账号
        bind() {
            // if (this.$utils.versionStringCompare(GSAppJsApi.Environment.getAppVersion(), '6.22.10') < 0) {
            //     var a = document.createElement("A");
            //     {
            //         a.target = "_blank";
            //         a.href = "https://app.gamersky.com/oth/versionupgrade/";
            //     }
            //     a.click();
            //     return false
            // } else {
            this.loading = true;
            // - 无畏契约-战绩-立即绑定     - 立即绑定按钮点击时
            GSAppJsApi.EventStatistics.recordEvent("Z100012", "", 0);
            if (!this.account) {
                this.$toast({
                    type: "error",
                    message: "请输入游戏昵称",
                });
                this.needLogin = true;
                this.loading = false;
                return;
            }
            //   输入账号，并点击按钮   - 无畏契约_统计模型_有效点击绑定按钮
            GSAppJsApi.EventStatistics.recordEvent("Z100109", "", 0);
            this.record(109, this.gamerskyUserId);
            // 绑定操作
            GSAppJsApi.User.loginTo((isComplated) => {
                if (!isComplated) {
                    this.loading = false;
                    return;
                }
                if (!this.isAccountBinded()) {
                    this.loading = false;
                    return;
                }
                if (isComplated) {
                    this.gamerskyUserId = GSAppJsApi.User.getCurrentUserId();
                    this.loading = true;
                    this.cancelAuthorizationPolling(true);

                    const params = {
                        valorantUserName: this.account,
                        gamerskyUserId: this.gamerskyUserId,
                        requestId: this.createAuthorizationRequestId(),
                        authAttempt: 0,
                    };
                    this.requestBindAccount(params, 0)
                        .then((res) => {
                            if (!res.error || res.error == null) {
                                this.completeBindSuccess();
                            } else {
                                if (res.error == "451") {
                                    this.openAuthorizationFlow(params, res);
                                } else if (res.error == "404") {
                                    this.completeBindFailure("绑定失败", true);
                                } else {
                                    this.completeBindFailure(res.error || "绑定失败", false);
                                }
                            }
                        })
                        .catch(() => {
                            this.completeBindFailure("绑定失败", false);
                        });
                }
            });

            // }
        },

        async bindRiotAccount(shopSession, expectedUserId, monitorTraceId, returnOperationStartedAt) {
            if (this.riotBinding) return false;
            const operationStartedAt = returnOperationStartedAt || Date.now();
            const requestId = this.riotBindRequestGate.begin();
            let bindingUserId = 0;
            const isCurrent = () => this.riotBindRequestGate.isCurrent(requestId)
                && (!bindingUserId || (currentGamerskyUserId() === bindingUserId
                    && Number(this.gamerskyUserId) === bindingUserId));
            this.riotBinding = true;
            this.loading = true;
            this.bindInfoRequestGate.invalidate();
            this.userDataRequestGate.invalidate();
            this.clearLoadingDelayTimer();
            let diagnosticStorage = null;
            try { diagnosticStorage = window.localStorage; } catch (error) { /* Diagnostics only. */ }
            const diagnostics = createRiotDiagnostics(diagnosticStorage, {
                traceId: monitorTraceId,
                isCurrent,
                onChange: (report) => { this.riotDiagnosticText = report; },
            });
            const monitor = createRiotFlowMonitor(inquiryApi, {
                traceId: diagnostics.traceId,
                scene: "bind",
                triggerType: "BIND",
                getUserId: () => this.gamerskyUserId,
                isCurrent,
            });
            let stage = "bind_started";
            let requestStartedAt = 0;
            let bindResponseReceived = false;
            let bindSubmitted = false;
            let clientFailureCode = "";
            const recordStage = (name, detail) => {
                stage = name;
                diagnostics.record(name, detail);
            };
            this.riotDiagnosticFailed = false;
            recordStage(stage);
            monitor.record("FLOW_STARTED");
            let session = null;
            try {
                const loginUserId = await this.ensureGamerskyLogin();
                if (!isCurrent()) return false;
                if (!loginUserId) {
                    recordStage("gamersky_login_cancelled");
                    this.loading = false;
                    return false;
                }
                this.gamerskyUserId = loginUserId;
                bindingUserId = Number(loginUserId);
                if (shopSession && Number(this.gamerskyUserId) !== Number(expectedUserId)) throw new Error("RIOT_ACCOUNT_MISMATCH");
                recordStage("gamersky_login_ready");
                session = shopSession || await loginWithShopRiotDialog(GSAppJsApi, {
                    isCurrent,
                    onStage: (name, detail) => {
                        recordStage(name, detail);
                        if (name === "login_window_open") monitor.record("LOGIN_PAGE_OPENED");
                        if (name === "login_callback") monitor.record("LOGIN_CALLBACK_RECEIVED");
                    },
                    scriptUrl: config.riotLoginScriptUrl,
                });
                if (!isCurrent()) return false;
                recordStage("session_ready");
                saveRiotRecordSession(window.localStorage, session);
                session = this.publishRiotSharedSession(session, loginUserId, operationStartedAt, isCurrent);
                this.riotAccountSession = session;
                recordStage("session_saved");
                monitor.record("SESSION_SAVED");
                const params = buildRiotBindRequest(this.gamerskyUserId, session, monitor.traceId);
                recordStage("bind_request_started");
                monitor.record("BIND_REQUEST_STARTED");
                requestStartedAt = Date.now();
                const bindRequest = config.riotClientFetchEnabled
                    ? prepareClientRequest(inquiryApi, GSAppJsApi, params, {
                        isCurrent: () => isCurrent() && Number(this.gamerskyUserId) === Number(loginUserId),
                    }).then(payload => {
                        if (!isCurrent() || Number(this.gamerskyUserId) !== Number(loginUserId)) throw new Error("RIOT_CLIENT_CANCELLED");
                        clientFailureCode = payload.clientError || "";
                        bindSubmitted = !payload.clientError;
                        return submitClientRequest(params => inquiryApi.bindRiotAccount(params), payload);
                    })
                    : (() => { bindSubmitted = true; return inquiryApi.bindRiotAccount(params); })();
                const res = await withTimeout(bindRequest, RIOT_DATA_REQUEST_TIMEOUT_MS);
                bindResponseReceived = !isUnconfirmedRiotBindingResponse(res, session.puuid);
                if (!isCurrent()) return false;
                recordStage("bind_response", {
                    ...summarizeRiotResponse(res),
                    requestElapsedMs: Date.now() - requestStartedAt,
                });
                if (!bindResponseReceived) throw new Error("RIOT_BIND_UNCONFIRMED");
                if ((res.sourceAccountId && res.sourceAccountId !== session.puuid)
                    || (res.dataSource && res.dataSource !== "RIOT_PD")) throw new Error("RIOT_ACCOUNT_MISMATCH");
                if (res.error || (res.code !== undefined && res.code !== 0) || !res.riotStats || !res.riotStats.view) {
                    throw new Error(res.error || "RIOT_BIND_FAILED");
                }
                this.account = res.valorantUserName;
                this.currentBindInfoId = res.bindInfoId;
                this.currentDataSource = normalizeSource(res.dataSource);
                this.currentSourceLabel = res.sourceLabel || "Riot";
                this.currentSourceAccountId = res.sourceAccountId || session.puuid;
                this.applyRefreshState(res);
                this.applyRiotStats(res.riotStats);
                this.binding = false;
                this.needLogin = false;
                this.loading = false;
                this.loadedValorantTrackerInfo = true;
                recordStage("view_applied");
                this.getBindAccountList();
                recordStage("bind_succeeded");
                monitor.record("FLOW_FINISHED", { success: true });
                return true;
            } catch (error) {
                if (!isCurrent()) return false;
                const failedAt = stage;
                const unconfirmed = bindSubmitted && !bindResponseReceived;
                if (unconfirmed) {
                    do {
                        const recovered = await this.recoverCompletedRiotBinding(
                            session, isCurrent, recordStage, requestStartedAt
                        );
                        if (!isCurrent()) return false;
                        if (recovered) {
                            this.riotDiagnosticFailed = false;
                            recordStage("bind_reconciled");
                            monitor.record("FLOW_FINISHED", { success: true });
                            return true;
                        }
                        // An unknown write outcome may only be rechecked, never resubmitted.
                    } while (await this.confirmRiotBindingRetry(isCurrent, true));
                }
                if (!isCurrent()) return false;
                diagnostics.record("bind_failed", { failedAt, ...summarizeRiotError(error) });
                monitor.record("FLOW_FINISHED", {
                    success: false,
                    failType: error && (error.code || error.message),
                });
                this.riotDiagnosticFailed = true;
                this.loading = false;
                this.needLogin = true;
                const errorCode = clientFailureCode || (error && (error.code || error.message));
                const dataRetryable = !unconfirmed && requestStartedAt > 0 && session
                    && bindingUserId && session.puuid && session.accessToken && session.entitlementsToken
                    && (isTransientNetworkError(error) || [
                        "RIOT_CLIENT_TIMEOUT", "RIOT_CLIENT_PLAN_FAILED", "RIOT_CLIENT_VERSION_UNAVAILABLE",
                        "RIOT_CLIENT_RAW_UNAVAILABLE", "RIOT_UPSTREAM_UNAVAILABLE", "RIOT_RESPONSE_INVALID",
                    ].includes(errorCode));
                if (dataRetryable) {
                    if (!await this.confirmRiotBindingRetry(isCurrent, false)) return false;
                    if (!isCurrent()) return false;
                    this.riotBinding = false;
                    // Preserve the original credential timestamp so retrying cannot overwrite a newer shared login.
                    return this.bindRiotAccount(session, bindingUserId, undefined, operationStartedAt);
                }
                const messages = {
                    RIOT_LOGIN_UNSUPPORTED: "当前客户端不支持拳头登录，请更新客户端后重试",
                    RIOT_LOGIN_CANCELLED: "已取消拳头登录",
                    RIOT_LOGIN_TIMEOUT: "拳头登录超时，请重试",
                    RIOT_ACCOUNT_MISMATCH: "拳头账号与当前选择不一致",
                    RIOT_STORAGE_UNAVAILABLE: "无法保存拳头登录信息，请重试",
                    RIOT_SESSION_EXPIRED: "Riot登录已失效，请重新登录后重试",
                    RIOT_COOKIE_EXPIRED: "Riot登录已失效，请重新登录后重试",
                    RIOT_SESSION_NOT_READY: "拳头登录信息未就绪，请重新登录后重试",
                    RIOT_RATE_LIMITED: "拳头服务器请求频繁，请稍后重试",
                };
                this.$toast({
                    type: "error",
                    message: unconfirmed ? "绑定结果尚未确认，请稍后再试"
                        : (messages[errorCode] || (session ? "战绩获取或绑定失败，请稍后重试" : "Riot账号登录未完成，请重试")),
                });
                return false;
            } finally {
                if (this.riotBindRequestGate.isCurrent(requestId)) {
                    this.riotBinding = false;
                    if (bindingUserId && currentGamerskyUserId() !== bindingUserId) this.loading = false;
                }
            }
        },

        async confirmRiotBindingRetry(isCurrent, unconfirmed) {
            if (!isCurrent()) return false;
            this.loading = false;
            try {
                await showAuthModal({
                    contentLines: unconfirmed
                        ? ["已登录，绑定结果暂未确认", "可重新确认，无需再次登录"]
                        : ["已登录，战绩获取暂未完成", "可重试获取，无需再次登录"],
                    confirmText: unconfirmed ? "重新确认" : "重试获取",
                    cancelText: "取消",
                });
                return isCurrent();
            } catch (_) {
                return false;
            }
        },

        async recoverCompletedRiotBinding(session, isCurrent, recordStage, requestStartedAt) {
            const puuid = session && session.puuid;
            if (!puuid || !this.gamerskyUserId || !isCurrent()) return false;
            try {
                recordStage("bind_reconcile_started");
                const requestElapsed = Number(requestStartedAt) > 0
                    ? Math.max(0, Date.now() - Number(requestStartedAt))
                    : 0;
                const remainingRequestWindow = Math.max(0, RIOT_DATA_REQUEST_TIMEOUT_MS - requestElapsed);
                const reconcileWindow = requestElapsed >= 30000
                    ? Math.max(10000, Math.min(40000, remainingRequestWindow + 5000))
                    : 10000;
                const reconcileDeadline = Date.now() + reconcileWindow;
                let listResponse = null;
                let matched = null;
                while (isCurrent() && Date.now() < reconcileDeadline && !matched) {
                    try {
                        listResponse = await withTimeout(inquiryApi.getBindAccountList({
                            gamerskyUserId: this.gamerskyUserId,
                        }), Math.min(5000, Math.max(1, reconcileDeadline - Date.now())));
                        if (listResponse && !listResponse.error
                            && (listResponse.code === undefined || listResponse.code === 0)
                            && Array.isArray(listResponse.bindAccountList)) {
                            matched = listResponse.bindAccountList.find((account) => (
                                normalizeSource(account && account.dataSource) === "RIOT_PD"
                                && account.sourceAccountId === puuid
                                && account.bindInfoId
                            ));
                        }
                    } catch (listError) {
                        listResponse = null;
                    }
                    if (!matched && Date.now() < reconcileDeadline) {
                        await new Promise((resolve) => setTimeout(resolve, 1000));
                    }
                }
                if (!matched) return false;

                const statsResponse = await withTimeout(inquiryApi.getRiotStats(buildRiotQueryRequest(
                    this.gamerskyUserId,
                    matched.bindInfoId,
                    puuid,
                    null,
                    false,
                    false,
                    "all",
                    "all"
                )), 15000);
                if (!isCurrent() || !statsResponse || statsResponse.error
                    || (statsResponse.code !== undefined && statsResponse.code !== 0)
                    || (statsResponse.sourceAccountId && statsResponse.sourceAccountId !== puuid)
                    || (statsResponse.dataSource && statsResponse.dataSource !== "RIOT_PD")
                    || !statsResponse.riotStats || !statsResponse.riotStats.view
                    || typeof statsResponse.riotStats.view !== "object" || Array.isArray(statsResponse.riotStats.view)) return false;

                this.changeAccountList = listResponse.bindAccountList.map((account) => ({
                    ...account,
                    dataSource: normalizeSource(account.dataSource),
                    sourceLabel: account.sourceLabel || "Tracker",
                    sourceAccountId: account.sourceAccountId || "",
                }));
                this.account = statsResponse.valorantUserName || matched.valorantUserName;
                this.currentBindInfoId = statsResponse.bindInfoId || matched.bindInfoId;
                this.currentDataSource = "RIOT_PD";
                this.currentSourceLabel = statsResponse.sourceLabel || matched.sourceLabel || "Riot";
                this.currentSourceAccountId = statsResponse.sourceAccountId || puuid;
                this.applyRefreshState(statsResponse);
                if (!this.applyRiotStats(statsResponse.riotStats)) return false;
                this.binding = false;
                this.needLogin = false;
                this.loading = false;
                this.loadedValorantTrackerInfo = true;
                recordStage("bind_reconcile_succeeded", { bindInfoId: this.currentBindInfoId });
                return true;
            } catch (reconcileError) {
                recordStage("bind_reconcile_failed", summarizeRiotError(reconcileError));
                return false;
            }
        },

        applyRiotStats(riotStats) {
            const view = riotStats && riotStats.view;
            if (!view) {
                return false;
            }
            this.riotStatsSnapshot = riotStats;
            this.modes = Array.isArray(riotStats.modes) ? riotStats.modes : [];
            this.seasons = riotSeasonOptions();
            const selectedSeason = this.seasons.find((season) => {
                const values = [season && season.name, season && season.label, season && season.value];
                return values.includes(view.season) || values.includes(view.passon);
            });
            this.selectSeasons = (selectedSeason && (selectedSeason.label || selectedSeason.name))
                || view.passon
                || (this.seasons[0] && (this.seasons[0].label || this.seasons[0].name))
                || "当前赛季";
            const modeViews = riotStats.modeViews && typeof riotStats.modeViews === "object"
                ? riotStats.modeViews : null;
            const selectedCode = normalizeModeCode(this.selectModes);
            const defaultCode = modeViews && modeViews.all
                ? (modeViews[selectedCode] ? selectedCode : "all")
                : normalizeModeCode(view.defaultMode || "competitive");
            return this.applyRiotMode(defaultCode);
        },

        applyRiotMode(modeCode, requestValue) {
            const snapshot = this.riotStatsSnapshot;
            if (!snapshot || !snapshot.view) return false;
            const normalizedCode = normalizeModeCode(modeCode);
            const modeViews = snapshot.modeViews && typeof snapshot.modeViews === "object"
                ? snapshot.modeViews : null;
            const nextView = modeViews
                ? modeViews[normalizedCode]
                : (normalizeModeCode(snapshot.view.defaultMode) === normalizedCode ? snapshot.view : null);
            if (!nextView) return false;
            const option = buildHeaderModeOptions(this.modes, "RIOT_PD")
                .find((item) => item.code === normalizedCode);
            this.selectModes = requestValue || (option && option.requestValue) || normalizedCode;
            this.valorantTrackerInfo = nextView;
            return true;
        },

        createAuthorizationRequestId() {
            return `valorant-auth-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        },

        authPollingLog(event, detail) {
            console.log(`[ValorantAuthPolling] ${new Date().toISOString()} ${event}`, detail || {});
        },

        requestBindAccount(params, authAttempt) {
            const startedAt = Date.now();
            this.authPollingLog("request_start", {
                requestId: params.requestId,
                authAttempt,
                account: params.valorantUserName,
            });
            return withTimeout(inquiryApi.bindAccount({
                ...params,
                authAttempt,
            }), TRACKER_DATA_REQUEST_TIMEOUT_MS).then((response) => {
                this.authPollingLog("request_completed", {
                    requestId: params.requestId,
                    authAttempt,
                    elapsedMs: Date.now() - startedAt,
                    error: response && response.error,
                });
                return response;
            }).catch((error) => {
                this.authPollingLog("request_exception", {
                    requestId: params.requestId,
                    authAttempt,
                    elapsedMs: Date.now() - startedAt,
                    error: error && error.message ? error.message : String(error),
                });
                throw error;
            });
        },

        completeBindSuccess() {
            this.cancelAuthorizationPolling(false);
            this.pendingAuthorizationBindParams = null;
            this.pendingAuthorizationSessionId = "";
            this.authorizationDialogOpen = false;
            this.binding = true;
            this.getBindInfo();
            this.getBindAccountList();
            this.needLogin = false;
            this.loading = false;
        },

        completeBindFailure(message, accountNotFound) {
            if (accountNotFound) {
                GSAppJsApi.EventStatistics.recordEvent("Z200449", "", 0);
            }
            GSAppJsApi.EventStatistics.recordEvent("Z100019", "", 0);
            this.cancelAuthorizationPolling(false);
            this.pendingAuthorizationBindParams = null;
            this.pendingAuthorizationSessionId = "";
            this.authorizationDialogOpen = false;
            this.loading = false;
            this.needLogin = true;
            this.$toast({
                type: "error",
                message,
            });
        },

        showAuthorizationLoadingToast() {
            this.authorizationLoadingToastOpen = true;
            this.$toast({
                type: "loading",
                message: "数据获取可能较慢（1-3分钟）<br />可稍后再来查看",
                time: "infinite",
            });
        },

        closeAuthorizationLoadingToast() {
            if (!this.authorizationLoadingToastOpen) {
                return;
            }
            this.authorizationLoadingToastOpen = false;
            this.$toast.close();
        },

        openAuthorizationFlow(params, bindResponse) {
            const authorizationSessionId = bindResponse && bindResponse.authorizationSessionId;
            this.authPollingLog("authorization_dialog_opening", {
                requestId: params.requestId,
                account: params.valorantUserName,
                authorizationSessionId,
            });
            this.cancelAuthorizationPolling(false);
            if (!authorizationSessionId) {
                this.completeBindFailure("授权服务暂不可用，请重试", false);
                return;
            }
            this.pendingAuthorizationBindParams = { ...params };
            this.pendingAuthorizationSessionId = authorizationSessionId;
            this.loading = false;
            this.needLogin = true;
            GSAppJsApi.EventStatistics.recordEvent("Z100020", "", 0);
            showAuthModal()
                .then(() => {
                    this.NoNeedBind = false;
                    GSAppJsApi.EventStatistics.recordEvent("Z200453", "", 0);
                    const authorizationScriptUrl = buildAuthorizationBridgeUrl(
                        config.baseUrl,
                        authorizationSessionId,
                        window.location.href
                    );
                    this.authorizationDialogOpen = true;
                    this.authPollingLog("authorization_dialog_script_ready", {
                        requestId: params.requestId,
                        authorizationSessionId,
                        authorizationScriptUrl,
                    });
                    GSAppJsApi.UI.openValorantLoginDialog(
                        "https://account.tracker.gg/auth/search?provider=riot&returnUrl=https://tracker.gg/auth/search/callback&state=valorant",
                        {},
                        authorizationScriptUrl,
                        () => {
                            this.authorizationDialogOpen = false;
                            this.authPollingLog("authorization_dialog_closed", {
                                requestId: this.pendingAuthorizationBindParams && this.pendingAuthorizationBindParams.requestId,
                                authorizationSessionId: this.pendingAuthorizationSessionId,
                                polling: this.authorizationPolling,
                            });
                            this.resumeAuthorizationStatusPolling("dialog_closed");
                        }
                    );
                    GSAppJsApi.EventStatistics.recordEvent("Z200461", "", 0);
                })
                .catch(() => {
                    this.authorizationDialogOpen = false;
                    this.cancelAuthorizationPolling(true);
                    this.completeBindFailure("绑定失败", false);
                });
        },

        waitForAuthorizationPoll(delay, flowId) {
            return new Promise((resolve) => {
                if (flowId !== this.authorizationFlowId) {
                    this.authPollingLog("wait_skipped_stale_flow", {
                        flowId,
                        currentFlowId: this.authorizationFlowId,
                    });
                    resolve(false);
                    return;
                }
                const waitStartedAt = Date.now();
                this.authPollingLog("wait_scheduled", {
                    flowId,
                    delayMs: delay,
                });
                this.authorizationWaitResolve = resolve;
                this.authorizationTimer = setTimeout(() => {
                    this.authorizationTimer = null;
                    this.authorizationWaitResolve = null;
                    this.authPollingLog("wait_fired", {
                        flowId,
                        expectedDelayMs: delay,
                        actualDelayMs: Date.now() - waitStartedAt,
                        timerDriftMs: Date.now() - waitStartedAt - delay,
                    });
                    resolve(flowId === this.authorizationFlowId);
                }, delay);
            });
        },

        requestAuthorizationStatus(sessionId) {
            const startedAt = Date.now();
            return withTimeout(inquiryApi.getAuthorizationStatus({
                sessionId,
                gamerskyUserId: this.gamerskyUserId,
            }), 15000).then((response) => {
                this.authPollingLog("status_request_completed", {
                    requestId: this.pendingAuthorizationBindParams && this.pendingAuthorizationBindParams.requestId,
                    authorizationSessionId: sessionId,
                    elapsedMs: Date.now() - startedAt,
                    status: response && response.status,
                    attemptCount: response && response.attemptCount,
                    error: response && response.error,
                });
                return response;
            }).catch((error) => {
                this.authPollingLog("status_request_exception", {
                    authorizationSessionId: sessionId,
                    elapsedMs: Date.now() - startedAt,
                    error: error && error.message ? error.message : String(error),
                });
                throw error;
            });
        },

        resumeAuthorizationStatusPolling(source) {
            if (this.authorizationPolling || !this.pendingAuthorizationSessionId) {
                this.authPollingLog("polling_start_ignored", {
                    source,
                    polling: this.authorizationPolling,
                    hasAuthorizationSession: Boolean(this.pendingAuthorizationSessionId),
                });
                return;
            }

            this.cancelAuthorizationPolling(false);
            const flowId = this.authorizationFlowId;
            const sessionId = this.pendingAuthorizationSessionId;
            this.authorizationPolling = true;
            this.loading = false;
            this.showAuthorizationLoadingToast();
            this.authPollingLog("status_polling_started", {
                source,
                requestId: this.pendingAuthorizationBindParams && this.pendingAuthorizationBindParams.requestId,
                authorizationSessionId: sessionId,
                flowId,
                intervalMs: 1000,
                maxDurationMs: TRACKER_AUTHORIZATION_TIMEOUT_MS,
                waitingMaxDurationMs: 20000,
            });

            pollAuthorizationSession({
                request: () => this.requestAuthorizationStatus(sessionId),
                wait: (delay) => this.waitForAuthorizationPoll(delay, flowId),
                isActive: () => this.authorizationPolling && flowId === this.authorizationFlowId,
                intervalMs: 1000,
                maxDurationMs: TRACKER_AUTHORIZATION_TIMEOUT_MS,
                waitingMaxDurationMs: 20000,
            }).then((result) => {
                if (flowId !== this.authorizationFlowId || result.status === "cancelled") {
                    this.authPollingLog("polling_result_ignored", {
                        requestId: this.pendingAuthorizationBindParams && this.pendingAuthorizationBindParams.requestId,
                        authorizationSessionId: sessionId,
                        flowId,
                        currentFlowId: this.authorizationFlowId,
                        status: result.status,
                    });
                    return;
                }

                this.authorizationPolling = false;
                this.authPollingLog("status_polling_finished", {
                    requestId: this.pendingAuthorizationBindParams && this.pendingAuthorizationBindParams.requestId,
                    authorizationSessionId: sessionId,
                    flowId,
                    status: result.status,
                    attempts: result.attempts,
                });
                if (result.status === "success") {
                    this.completeBindSuccess();
                    return;
                }
                if (result.status === "not_found") {
                    this.completeBindFailure("绑定失败", true);
                    return;
                }
                this.completeBindFailure("授权失败，请重试", false);
            });
        },

        cancelAuthorizationPolling(clearPending) {
            this.authPollingLog("polling_cancelled", {
                requestId: this.pendingAuthorizationBindParams && this.pendingAuthorizationBindParams.requestId,
                clearPending,
                previousFlowId: this.authorizationFlowId,
                polling: this.authorizationPolling,
            });
            this.authorizationFlowId += 1;
            this.authorizationPolling = false;
            this.closeAuthorizationLoadingToast();
            if (this.authorizationTimer) {
                clearTimeout(this.authorizationTimer);
                this.authorizationTimer = null;
            }
            if (this.authorizationWaitResolve) {
                this.authorizationWaitResolve(false);
                this.authorizationWaitResolve = null;
            }
            if (clearPending) {
                this.pendingAuthorizationBindParams = null;
                this.pendingAuthorizationSessionId = "";
                this.authorizationDialogOpen = false;
            }
        },

        // 解除绑定
        unBind() {
            inquiryApi
                .unBindAccount({
                    gamerskyUserId: this.gamerskyUserId,
                    bindInfoId: this.currentBindInfoId,
                })
                .then(() => {
                    this.$toast({
                        type: "success",
                        message: "解绑成功",
                    });
                    location.reload();
                })
                .catch(() => {});
        },

        returnToBindingAfterRefreshNotFound(requestId) {
            const failedAccount = {
                bindInfoId: this.currentBindInfoId,
                valorantUserName: this.account,
                dataSource: this.currentDataSource,
            };
            const params = buildBindingSelection(this.gamerskyUserId, failedAccount);
            this.loading = true;

            return withTimeout(inquiryApi.unBindAccount(params), 15000)
                .then((res) => {
                    if (!this.userDataRequestGate.isCurrent(requestId)) {
                        return false;
                    }
                    if (res.error) {
                        throw new Error("解绑失败");
                    }

                    this.bindInfoRequestGate.invalidate();
                    this.userDataRequestGate.invalidate();
                    this.clearRefreshCooldownTimer();
                    this.changeAccountList = this.changeAccountList.filter((account) => !isAccountActive(
                        account, failedAccount.bindInfoId, failedAccount.valorantUserName, failedAccount.dataSource
                    ));
                    this.changeAccountModel = false;
                    this.currentBindInfoId = null;
                    this.currentDataSource = "TRACKER";
                    this.currentSourceLabel = "Tracker";
                    this.currentSourceAccountId = "";
                    this.account = "";
                    this.valorantTrackerInfo = null;
                    this.riotStatsSnapshot = null;
                    this.modes = [];
                    this.seasons = [];
                    this.selectModes = "";
                    this.selectSeasons = "";
                    this.loadedValorantTrackerInfo = false;
                    this.binding = false;
                    this.isFreshing = false;
                    this.canRefresh = true;
                    this.nextRefreshTime = null;
                    this.lastRefreshTime = null;
                    this.refreshInProgress = false;
                    this.loadError = false;
                    this.loading = false;
                    this.needLogin = true;
                    this.$toast({ type: "error", message: "该用户名不存在，请重新绑定" });
                    return false;
                })
                .catch(() => {
                    if (!this.userDataRequestGate.isCurrent(requestId)) {
                        return false;
                    }
                    this.loading = false;
                    this.isFreshing = false;
                    this.$toast({ type: "error", message: "该用户名不存在，解绑失败，请重试" });
                    return false;
                });
        },

        // 获取用户绑定账号信息
        getBindInfo() {
            if (!this.gamerskyUserId) {
                this.needLogin = true;
                this.loading = false;
                return false;
            }
            const requestId = this.bindInfoRequestGate.begin();
            this.userDataRequestGate.invalidate();
            this.clearLoadingDelayTimer();
            const bindInfo = {
                gamerskyUserId: this.gamerskyUserId,

                // gamerskyUserId: 8059792,
            };
            return withTimeout(inquiryApi.getBindInfo(bindInfo), 15000)
                .then((res) => {
                    if (!this.bindInfoRequestGate.isCurrent(requestId)) {
                        return false;
                    }
                    // 有绑定账号
                    if (!res.error && res.valorantUserName) {
                        this.account = res.valorantUserName;
                        this.currentBindInfoId = res.bindInfoId || null;
                        this.currentDataSource = normalizeSource(res.dataSource);
                        this.currentSourceLabel = res.sourceLabel || "Tracker";
                        this.currentSourceAccountId = res.sourceAccountId || "";
                        this.needLogin = false;
                        this.riotStatsSnapshot = null;
                        this.selectModes = "";
                        this.selectSeasons = "";
                        return this.getUserData(false, { showLoading: this.loading });
                    } else {
                        this.valorantTrackerInfo = null;
                        this.riotStatsSnapshot = null;
                        this.needLogin = true;
                        this.loading = false;
                    }
                    console.log(res);
                    return false;
                })
                .catch(() => {
                    if (!this.bindInfoRequestGate.isCurrent(requestId)) {
                        return false;
                    }
                    this.loading = false;
                    this.binding = false;
                    this.valorantTrackerInfo = null;
                    this.loadError = true;
                    return false;
                });
        },

        // 获取用户战绩信息
        getUserData(isFresh, options = {}) {
            const requestId = this.userDataRequestGate.begin();
            const requestStartedAt = Date.now();
            const previousRiotRefreshTime = this.lastRefreshTime;
            this.clearLoadingDelayTimer();
            this.loadError = false;
            if (options.showLoading) {
                this.loading = true;
            } else if (options.delayLoading) {
                this.scheduleLoadingDelay(requestId);
            }

            const isRiotSource = this.currentDataSource === "RIOT_PD";
            if (isRiotSource) this.adoptCurrentRiotSharedSession();
            const isRiotRefreshRequest = isRiotSource && (isFresh || options.autoRefresh === true);
            const riotMonitorTraceId = isRiotRefreshRequest
                ? (options.monitorTraceId || createTraceId("riot-refresh")) : null;
            const riotTriggerType = options.triggerType
                || (options.autoRefresh === true ? "AUTO" : "MANUAL");
            const riotSessionAlreadyRenewed = options.sessionRenewed === true || options.postRenew === true || Boolean(options.renewalFallback);
            if (isRiotRefreshRequest && !riotSessionAlreadyRenewed) {
                // Match the shop flow: renew the Riot session before every real data refresh.
                this.riotSessionRecoveryAttempt = 0;
                return this.recoverRiotSessionAndRetry(isFresh, {
                    ...options,
                    monitorTraceId: riotMonitorTraceId,
                    triggerType: riotTriggerType,
                });
            }
            let requestPromise;
            let riotSession = null;
            if (isRiotSource) {
                try {
                    riotSession = readRiotAccountSession(
                        window.localStorage,
                        this.currentSourceAccountId,
                        this.riotAccountSession
                    );
                    this.riotAccountSession = riotSession;
                } catch (error) {
                    if (isRiotRefreshRequest) {
                        if (options.renewalFallback) options.renewalFallback.loginRequired = true;
                        this.clearLoadingDelayTimer();
                        this.loading = false;
                        this.isFreshing = false;
                        return this.recoverRiotSessionAndRetry(isFresh, {
                            ...options,
                            monitorTraceId: riotMonitorTraceId,
                            triggerType: riotTriggerType,
                            skipSilentRenewal: riotSessionAlreadyRenewed,
                            renewalFlowStarted: options.renewalFlowStarted === true,
                        });
                    }
                }
                const queryParams = buildRiotQueryRequest(
                    this.gamerskyUserId,
                    this.currentBindInfoId,
                    this.currentSourceAccountId,
                    riotSession,
                    isFresh,
                    options.autoRefresh === true,
                    normalizeModeCode(this.selectModes) || "all",
                    this.selectSeasons,
                    riotMonitorTraceId
                );
                const clientScopeUserId = this.gamerskyUserId;
                queryParams.clientFetch = config.riotClientFetchEnabled === true;
                const clientScopePuuid = this.currentSourceAccountId;
                const clientIsCurrent = () => this.userDataRequestGate.isCurrent(requestId)
                    && this.gamerskyUserId === clientScopeUserId && this.currentSourceAccountId === clientScopePuuid;
                requestPromise = config.riotClientFetchEnabled && isRiotRefreshRequest
                    ? prepareClientRequest(inquiryApi, GSAppJsApi, queryParams, { isCurrent: clientIsCurrent })
                        .then(payload => {
                            if (!clientIsCurrent()) throw new Error("RIOT_CLIENT_CANCELLED");
                            return submitClientRequest(params => inquiryApi.getRiotStats(params), payload);
                        })
                    : inquiryApi.getRiotStats(queryParams);
            } else {
                requestPromise = inquiryApi.getTrackeInfo({
                    gamerskyUserId: this.gamerskyUserId,
                    mode: this.selectModes,
                    season: this.selectSeasons,
                    isUpdate: isFresh,
                });
            }

            return withTimeout(requestPromise, isRiotSource
                ? RIOT_DATA_REQUEST_TIMEOUT_MS : TRACKER_DATA_REQUEST_TIMEOUT_MS)
                .then((res) => {
                    if (!this.userDataRequestGate.isCurrent(requestId)) {
                        return false;
                    }
                    // A resolved gateway response is not necessarily a completed business response.
                    if (isRiotRefreshRequest && (!res || typeof res !== "object" || Array.isArray(res)
                        || (!res.error && !(res.riotStats && res.riotStats.view)))) {
                        console.warn("[ValorantRiotRefresh] response completion unconfirmed", {
                            requestId,
                            elapsedMs: Date.now() - requestStartedAt,
                            responseType: res === null ? "null" : typeof res,
                        });
                        throw Object.assign(new Error("RIOT_RESPONSE_UNCONFIRMED"), { code: "RIOT_RESPONSE_UNCONFIRMED" });
                    }
                    this.clearLoadingDelayTimer();
                    this.applyRefreshState(res);
                    const trackerInfo = isRiotSource
                        ? (res.riotStats && res.riotStats.view)
                        : res.valorantTrackerInfo;
                    if (res.error || !trackerInfo) {
                        const preserveCurrentData = shouldPreserveCurrentData(
                            isFresh,
                            options.preserveCurrentData,
                            this.valorantTrackerInfo
                        );
                        if (isRiotRefreshRequest && isRiotSessionExpired(res.error)) {
                            if (options.renewalFallback && options.renewalFallback.renewalUnconfirmed) {
                                this.loading = false;
                                this.isFreshing = false;
                                if (!options.silentFailure) this.$toast({
                                    type: "error", message: "登录状态暂未恢复，请稍后重试",
                                });
                                return false;
                            }
                            if (options.renewalFallback) options.renewalFallback.loginRequired = true;
                            this.loading = false;
                            return this.recoverRiotSessionAndRetry(isFresh, {
                                ...options,
                                monitorTraceId: riotMonitorTraceId,
                                triggerType: riotTriggerType,
                                skipSilentRenewal: riotSessionAlreadyRenewed,
                                renewalFlowStarted: options.renewalFlowStarted === true,
                            });
                        }
                        if (isRiotRefreshRequest) {
                            console.warn("[ValorantRiotRefresh] request returned an error", {
                                requestId,
                                elapsedMs: Date.now() - requestStartedAt,
                                error: res.error || "RIOT_STATS_EMPTY",
                                retryable: Boolean(res.retryable),
                            });
                        }
                        if (isFresh) {
                            GSAppJsApi.EventStatistics.recordEvent("Z200447", "", 0);
                            this.isFreshing = false;
                            this.loading = false;
                            if (this.isCurrentUser && shouldReturnToBindingAfterRefresh(isFresh, res.error, this.currentDataSource)) {
                                return this.returnToBindingAfterRefreshNotFound(requestId);
                            }
                            this.$toast({
                                type: "error",
                                message: "更新失败",
                            });
                            return false;
                        }
                        if (preserveCurrentData) {
                            this.binding = false;
                            this.loading = false;
                            this.loadError = false;
                            if (!options.silentFailure) {
                                this.$toast({
                                    type: "error",
                                    message: "数据加载失败，请重试",
                                });
                            }
                            return false;
                        }
                        this.valorantTrackerInfo = null;
                        this.binding = false;
                        this.loading = false;
                        this.loadError = true;
                        return false;
                    }

                    this.currentBindInfoId = res.bindInfoId || this.currentBindInfoId;
                    this.account = res.valorantUserName || this.account;
                    this.currentDataSource = normalizeSource(res.dataSource || this.currentDataSource);
                    this.currentSourceLabel = res.sourceLabel || this.currentSourceLabel;
                    this.currentSourceAccountId = res.sourceAccountId || this.currentSourceAccountId;

                    // alert(JSON.stringify(res.code))
                    // 无畏契约战绩_绑定成功
                    if (this.binding && !isFresh) {
                        GSAppJsApi.EventStatistics.recordEvent("Z100013", "", 0);
                    }

                    if (isRiotSource) {
                        this.applyRiotStats(res.riotStats);
                    } else {
                        this.riotStatsSnapshot = null;
                        this.valorantTrackerInfo = trackerInfo;
                        this.modes = res.modes;
                        this.selectModes = trackerInfo.defaultMode;
                        this.seasons = res.seasons;
                        this.selectSeasons = trackerInfo.passon;
                    }
                    if (isFresh) {
                        GSAppJsApi.EventStatistics.recordEvent("Z200447", "", 0);
                        this.isFreshing = false;
                    }
                    if (isRiotRefreshRequest) this.riotSessionRecoveryAttempt = 0;
                    if (!this.loadedValorantTrackerInfo) {
                        GSAppJsApi.EventStatistics.recordEvent("Z100011", "", 0);
                    }
                    this.loadedValorantTrackerInfo = true;
                    this.binding = false;
                    this.loading = false;
                    if (isRiotSource
                        && !isFresh
                        && options.autoRefresh !== true
                        && options.skipAutoRefresh !== true
                        && riotSession
                        && shouldAutoRefreshRiot(res.lastRefreshTime)) {
                        const expectedBindInfoId = this.currentBindInfoId;
                        const expectedSourceAccountId = this.currentSourceAccountId;
                        this.$nextTick(() => {
                            if (this.currentDataSource === "RIOT_PD"
                                && this.currentBindInfoId === expectedBindInfoId
                                && this.currentSourceAccountId === expectedSourceAccountId) {
                                this.startRiotAutoRefresh(expectedBindInfoId, expectedSourceAccountId);
                            }
                        });
                    }
                    return true;

                    // if (res.code != 0) {
                    //     var isReFresh = isFresh ? true : false
                    //     var mode = this.modes.length > 0 ? this.modes.find(element => element.label === this.selectModes)?.value : '';
                    //     var season = this.seasons.length > 0 ? this.seasons.find(element => element.label === this.selectSeasons)?.value : '';

                    //     // 调用爬虫
                    //     var CurrentAddress = 'https://tracker.gg/valorant/profile/riot/' + encodeURIComponent(this.account) + '/overview?UserName=' + encodeURIComponent(this.account) + '&mode=' + encodeURIComponent(mode) + '&season=' + encodeURIComponent(season) + '&isReFresh=' + encodeURIComponent(isReFresh);
                    //     var CrawlerAddress = 'https://app.gamersky.com/tools/appGotJsTo/valorant_stats_crawler/getData.js';
                    //     // var CrawlerAddress = 'https://project-test.gamersky.com/app/valorant/getData.js';

                    //     // alert(CurrentAddress)
                    //     if (mode || season) {
                    //         CrawlerAddress = 'https://app.gamersky.com/tools/appGotJsTo/valorant_stats_crawler/getSeasonAndModeData.js';
                    //         // CrawlerAddress = 'https://project-test.gamersky.com/app/valorant/getSeasonAndModeData.js';
                    //     }

                    //     // 开启监听  是否弹出登录窗口
                    //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.riotLogin", (response) => {
                    //         if (response == 'dengLuQuanTou') {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100017', '', 0);
                    //         }
                    //     });

                    //     // 开启监听  开始抓取数据
                    //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.getData", (response) => {
                    //         if (response == 'kaiShiZhuaQu') {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100018', '', 0);
                    //         }
                    //     });

                    //     that.$utils.CallCrawler(CurrentAddress, CrawlerAddress, (res) => {
                    //         if (res == 'chengGong') {
                    //             that.getUserData()
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100015', '', 0);
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100019', '', 0);
                    //             that.$toast({
                    //                 type: "success",
                    //                 message: "加载成功",
                    //                 time: 2000,
                    //             });
                    //         } else {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100020', '', 0);
                    //             that.$toast({
                    //                 type: "error",
                    //                 message: "加载失败",
                    //                 time: 2000,
                    //             });
                    //         }
                    //     })
                    // } else {
                    //     clearTimeout(ShowLoding);

                    //     if (res.error) {
                    //         this.getInfo();
                    //     } else {
                    //         // 无畏契约战绩_绑定成功
                    //         if (this.binding && !isFresh) {
                    //             GSAppJsApi.EventStatistics.recordEvent('Z100013', '', 0);
                    //             this.binding = false;
                    //         }

                    //         this.valorantTrackerInfo = res.valorantTrackerInfo;

                    //         this.modes = res.modes
                    //         this.selectModes = res.valorantTrackerInfo.defaultMode

                    //         this.seasons = res.seasons
                    //         this.selectSeasons = res.valorantTrackerInfo.passon

                    //         this.loading = false;
                    //         // 安卓端， 或 版本号大于等于 6.22.52 上报总 和 已绑定访问统计
                    //         if (this.isAppVersionGreaterThanOrEqual || this.isAndroid) {
                    //             if (this.isCurrentUser && !isFresh && this.didWindowGetFocus) {
                    //                 GSAppJsApi.EventStatistics.recordEvent('Z100011', '', 0);
                    //                 GSAppJsApi.EventStatistics.recordEvent("Z100089", "无畏契约", 0);
                    //                 GSAppJsApi.EventStatistics.recordEvent("A13319_全局_游戏工具", "无畏契约战绩查询", 0);
                    //                 GSAppJsApi.UMeng.recordEvent('A13319_全局_游戏工具', '无畏契约战绩查询');
                    //             }
                    //         }
                    //         this.loadedValorantTrackerInfo = true;

                    //         this.$toast({
                    //             type: "success",
                    //             message: "加载成功",
                    //             time: 2000,
                    //         });

                    //         if (isFresh) {
                    //             this.isFreshing = false
                    //         }
                    //     }
                    // }
                    // this.getBindAccountList();
                })
                .catch(async (error) => {
                    if (!this.userDataRequestGate.isCurrent(requestId)) {
                        return false;
                    }
                    this.clearLoadingDelayTimer();
                    this.loading = false;
                    if (isRiotRefreshRequest && error && (error.code || error.message) === 'RIOT_CLIENT_CANCELLED') {
                        this.isFreshing = false;
                        return false;
                    }
                    if (isFresh || isRiotRefreshRequest) {
                        if (isRiotSource) {
                            console.warn("[ValorantRiotRefresh] request transport failed", {
                                requestId,
                                elapsedMs: Date.now() - requestStartedAt,
                                error: error && (error.code || error.message || error.name),
                            });
                        }
                        if (isRiotRefreshRequest) this.isFreshing = true;
                        if (isRiotRefreshRequest && await this.recoverCompletedRiotRefresh(
                            requestId,
                            requestStartedAt,
                            previousRiotRefreshTime
                        )) {
                            return true;
                        }
                        if (!this.userDataRequestGate.isCurrent(requestId)) return false;
                        this.isFreshing = false;
                        this.$toast({
                            type: "error",
                            message: "更新失败",
                        });
                        return false;
                    }
                    this.isFreshing = false;
                    if (shouldPreserveCurrentData(false, options.preserveCurrentData, this.valorantTrackerInfo)) {
                        this.binding = false;
                        this.loadError = false;
                        if (!options.silentFailure) {
                            this.$toast({
                                type: "error",
                                message: "数据加载失败，请重试",
                            });
                        }
                        return false;
                    }
                    this.valorantTrackerInfo = null;
                    this.binding = false;
                    this.loadError = true;
                    return false;
                });
        },

        DetermineVersion() {
            if (this.$utils.versionStringCompare(GSAppJsApi.Environment.getAppVersion(), "6.22.30") < 0) {
                this.VersionInterceptionDisplay = true;
                this.Upgrade();
            }
        },
        Upgrade() {
            var a = document.createElement("A");
            {
                a.target = "_blank";
                a.href = "https://app.gamersky.com/oth/versionupgrade/";
            }
            a.click();
        },
        getInfo(isReFresh) {
            if (isReFresh && (this.isFreshing || !this.canRefresh || this.refreshInProgress)) {
                return;
            }
            this.loadError = false;
            this.isFreshing = Boolean(isReFresh);
            if (isReFresh && this.currentDataSource === "RIOT_PD") {
                this.riotSessionRecoveryAttempt = 0;
            }
            if (isReFresh) {
                GSAppJsApi.EventStatistics.recordEvent("Z100014", "刷新账号", 0);
                GSAppJsApi.EventStatistics.recordEvent("Z200446", "", 0);
            } else {
                GSAppJsApi.EventStatistics.recordEvent("Z100014", "", 0);
            }
            return this.getUserData(isReFresh, { delayLoading: !isReFresh });

            // if (this.$utils.versionStringCompare(GSAppJsApi.Environment.getAppVersion(), '6.22.10') < 0) {
            //     // 老版本
            //     GSAppJsApi.invokeUrlCommand('https://app.gamersky.com/oth/versionupgrade/?gsAppPageName=valorantCrawer&valorantUserName=' + encodeURIComponent(this.account));
            //     // this.$utils.openWithNewWindow('https://app.gamersky.com/oth/versionupgrade/?gsAppPageName=valorantCrawer&valorantUserName=' + this.account);
            //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.valorant.userdatacraw", (response) => {
            //         this.loading = false;
            //         this.needLogin = false;
            //         if (response.crawResult == 'chengGong') {
            //             GSAppJsApi.EventStatistics.recordEvent('Z100015', '', 0);

            //         } else if (response.crawResult == 'shiBai') {
            //             // 失败
            //             this.loadError = true;
            //             this.isFreshing = false;

            //         } else if (response.crawResult == 'yongHuBuCunZai') {
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '账号不存在，请检查并重试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();

            //         }else{
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '数据源波动中<br>请稍后再试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();

            //         }
            //         this.isFreshing = false;

            //     });
            // } else {
            //     var CurrentAddress = 'https://tracker.gg/valorant/profile/riot/' + encodeURIComponent(this.account) + '/overview?UserName=' + encodeURIComponent(this.account) + '&isReFresh=' + encodeURIComponent(isReFreshText);
            //     // var CrawlerAddress = 'https://app.gamersky.com/tools/appGotJsTo/valorant_stats_crawler/getData.js';
            //     var CrawlerAddress = 'https://project-test.gamersky.com/app/valorant/getData.js';
            //     alert(CurrentAddress)

            //     // 开启监听  是否弹出登录窗口
            //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.riotLogin", (response) => {
            //         if (response == 'dengLuQuanTou') {
            //             GSAppJsApi.EventStatistics.recordEvent('Z100017', '', 0);
            //         }
            //     });

            //     // 开启监听  开始抓取数据
            //     GSAppJsApi.UI.registerNotificationListener("gamersky.app.crawler.state.getData", (response) => {
            //         if (response == 'kaiShiZhuaQu') {
            //             GSAppJsApi.EventStatistics.recordEvent('Z100018', '', 0);
            //         }
            //     });
            //     that.$utils.CallCrawler(CurrentAddress, CrawlerAddress, (res) => {
            //         if (res == 'chengGong') {
            //             if (isReFresh) {
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100015', '刷新账号', 0);
            //                 // 点击更新更新成功
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100019', '', 0);
            //             } else {
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100015', '', 0);
            //                 // 无畏契约_统计模型_绑定成功
            //                 GSAppJsApi.EventStatistics.recordEvent('Z100117', '', 0);
            //                 this.record(117, this.gamerskyUserId);
            //             }
            //             var message = isReFresh ? '更新成功' : '绑定成功'
            //             that.isFreshing = false;
            //             that.$toast({
            //                 type: 'success',
            //                 message: message
            //             })
            //             that.getUserData()
            //         } else if (res == 'yongHuBuCunZai') {
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.loading = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '账号不存在，请检查并重试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();

            //         }else if(res == 'renJiYanZheng' || res == 'faShengCuoWu'){
            //             // 用户不存在
            //             this.loadError = false;
            //             this.isFreshing = false;
            //             this.loading = false;
            //             this.$toast({
            //                 type: "error",
            //                 message: '数据源波动中<br>请稍后再试',
            //             });
            //             this.needLogin = true;
            //             this.unBind();
            //         } else {
            //             that.isFreshing = false;
            //             GSAppJsApi.EventStatistics.recordEvent('Z100020', '', 0);
            //             that.loading = false;
            //             that.$toast({
            //                 type: 'error',
            //                 message: '更新失败'
            //             })
            //         }
            //     })
            // }
        },

        getQuickInputList() {
            const params = {
                gamerskyUserId: this.gamerskyUserId,
                // gamerskyUserId: 8059792
            };
            inquiryApi.getQuickAccounts(params).then((res) => {
                console.log("res", res);
                if (!res.error) {
                    this.accountList = res.data;
                }
            });
        },
        changeAccount() {
            this.changeAccountModel = true;
            // this.valorantTrackerInfo = {};
        },
        addAccount() {
            this.riotBindRequestGate.invalidate();
            this.riotBinding = false;
            this.bindInfoRequestGate.invalidate();
            this.userDataRequestGate.invalidate();
            this.clearLoadingDelayTimer();
            this.isFreshing = false;
            this.record(108, this.gamerskyUserId);
            this.changeAccountModel = false;
            this.needLogin = true;
            this.loading = false;
            this.account = "";
            this.riotStatsSnapshot = null;
            this.selectModes = "";
            this.selectSeasons = "";
        },
    },
};
</script>

<style lang="scss">
html,
body {
    background: #14141a !important;
}
</style>

<style lang="scss" scoped>
#app {
    margin: 0 auto;
    // max-width: 700px;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: hidden;
    position: relative;
    background: #14141a;
    font-family: PingFang SC, PingFang SC-Bold;

    &.bindingPage { background: #0d151e; }

    .riotDiagnostics {
        position: relative;
        z-index: 1;
        max-width: 700px;
        margin: 0 auto;
        padding: 8px 12px;
        box-sizing: border-box;
        background: #202026;
        color: #fff;
        font-size: 12px;

        summary { cursor: pointer; line-height: 20px; }
        button {
            display: block;
            width: 88px;
            height: 28px;
            margin-top: 8px;
            border: 1px solid #555;
            border-radius: 0;
            background: #303039;
            color: #fff;
            font: inherit;

            &:disabled { opacity: .5; }
        }
        textarea {
            display: block;
            width: 100%;
            height: 240px;
            margin-top: 8px;
            padding: 8px;
            box-sizing: border-box;
            border: 1px solid #555;
            border-radius: 0;
            background: #14141a;
            color: #fff;
            font: 12px/18px monospace;
            resize: none;
            -webkit-user-select: text;
            user-select: text;
            -webkit-touch-callout: default;
        }
    }

    &.notScroll {
        overflow: hidden;
    }

    .MaskUpgradeVersionTemplate {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        max-width: 700px;
        width: 100%;
        height: 100vh;
    }

    .contentArea {
        margin: 0 auto;
        position: relative;
        max-width: 700px;
        height: 100vh;
        background: url("../../assets/image/img_bg.png") no-repeat top / 100% auto;
        &.bindingLanding {
            max-width: none;
            height: auto;
            min-height: 100vh;
            background: #0d151e;
        }
        .loading {
            position: absolute;
            top: 40%;
            left: 50%;
            width: 30px;
            height: 30px;
            background: url("../../assets/image/loading.png") no-repeat top / 100%;
            transform: translate(-50%, -50%);
            animation: rotate 1s linear infinite;
        }
    }

    .container {
        width: 100%;
        padding: 50vh 52px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;

        .topTips {
            width: 100%;
            position: absolute;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: Regular;
            text-align: center;
            color: rgba(255, 255, 255, 0.5);
            height: 32px;
            background: rgba(235, 65, 61, 0.1);
        }

        input {
            padding-left: 10px;
            height: 44px;
            width: 100%;
            background: #192129;
            border: 0.5px solid #26313c;
            border-radius: 4px;
            color: #d7d7d9;
            box-sizing: border-box;

            &::placeholder {
                color: #3f424a;
            }
        }

        .quickInput {
            margin-top: 16px;
            width: 100%;

            .label {
                width: 84px;
                height: 17px;
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: left;
                color: #48484b;
                line-height: 16px;
            }

            .accountList {
                span {
                    display: inline-block;
                    margin: 8px 8px 0 0;
                    padding: 5px 8px;
                    font-size: 12px;
                    background: rgba(25, 33, 41, 0);
                    border: 0.5px solid #1c2229;
                    border-radius: 4px;
                    color: #717173;
                }
            }
        }

        .bindBtn {
            margin-top: 16px;
            width: 100%;
            height: 40px;
            background: #eb413d;
            border-radius: 3px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: bold;
            text-align: center;
            color: #ffffff;
            line-height: 40px;
        }

        .riotBindBtn {
            margin-top: 10px;
            width: 100%;
            height: 40px;
            border: 1px solid rgba(255, 255, 255, 0.45);
            border-radius: 3px;
            font-size: 14px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            line-height: 38px;
        }

        .tips {
            margin-top: 20px;
            opacity: 0.3;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: center;
            color: #ffffff;

            .tip-line-1 {
                margin-bottom: 10px;
            }
        }
    }

    .mainArea {
        margin: 0 auto;
        position: relative;
        max-width: 700px;
        height: 100vh;
        background: #14141a url("../../assets/image/valorant-record-bg.png") no-repeat top / 100% auto;
        overflow: auto;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }

        .loading {
            position: relative;
            top: 200px;
            left: 50%;
            width: 46px;
            height: 46px;
            background: url("../../assets/image/loading.png") no-repeat top / 100%;
            transform: translate(-50%, -50%);
            animation: rotate 1s linear infinite;
        }

        .loadingTxt {
            color: rgb(255, 255, 255);
            position: relative;
            top: 180px;
            /* width: 80%; */
            text-align: center;
            margin: 0 20px;
            color: #55555d;
            font-size: 12px;
            line-height: 20px;

            span {
                display: block;
                margin-top: 8px;
                margin-bottom: 18px;
                font-size: 14px;
                color: #a3a3a6;
                line-height: 20px;
            }
        }

        .loadError {
            position: relative;
            top: 277px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: center;
            color: #ffffff;

            .dataErrorTips {
                opacity: 0.3;
            }

            .reloadDataBtn {
                margin: 20px auto;
                width: 172px;
                height: 42px;
                background: #eb413d;
                border-radius: 3px;
                font-size: 16px;
                font-family: PingFang SC, PingFang SC-Medium;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
                line-height: 42px;
            }
        }
    }

    .inquiryInfo {
        padding: 16px;
        width: 100%;
        height: auto;
        box-sizing: border-box;

        .accountInfo {
            display: flex;
            align-items: center;
            gap: 16px;

            .infoPhoto {
                position: relative;
                width: 80px;
                height: 80px;
                flex: 0 0 80px;
                overflow: hidden;

                img {
                    display: block;
                    width: 80px;
                    height: 80px;
                    object-fit: cover;
                }

                .refreshInfo {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 80px;
                    height: 16px;
                    background: rgba(0, 0, 0, 0.5);
                    font-size: 10px;
                    color: rgba(255, 255, 255, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i {
                        margin-right: 2px;
                        width: 12px;
                        height: 12px;
                        display: inline-block;
                        background: url("../../assets/image/icon_ShuaXin.png") no-repeat center / 12px;
                        opacity: 0.6;
                    }

                    &.isFreshing {
                        i {
                            background: url("../../assets/image/icon_LoadingHuaBan.gif") no-repeat center / 12px;
                        }
                    }
                }
            }

            .infoAccount {
                display: flex;
                flex-direction: column;
                margin-left: 0;
                flex-grow: 1;
                min-width: 0;
                // justify-content: center;

                .infoTitle {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-end;
                    gap: 8px;
                    color: rgba(255, 255, 255, 0.5);
                    height: 44px;
                    margin-top: 0;
                }

                .accountName {
                    flex: 1 1 0;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    gap: 2px;
                    overflow: hidden;

                    .title {
                        display: block;
                        width: 100%;
                        height: 22px;
                        opacity: 0.9;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 17px;
                        font-family: PingFang SC, PingFang SC-Semibold;
                        font-weight: 600;
                        text-align: left;
                        color: #ffffff;
                        line-height: 22px;
                        white-space: nowrap;
                    }

                    .accountMeta {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        height: 20px;
                    }

                    .ltitle {
                        flex: 0 0 auto;
                        white-space: nowrap;
                        font-size: 13px;
                        line-height: 20px;
                        color: rgba(255, 255, 255, 0.6);
                    }
                }

                .level {
                    flex: 0 0 auto;
                    box-sizing: border-box;
                    height: 18px;
                    padding: 2px 4px;
                    background: rgba(255, 255, 255, 0.1);
                    color: rgba(255, 255, 255, 0.6);
                    font-size: 9px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    line-height: 14px;
                    white-space: nowrap;
                }

                .changeIcon {
                    flex: 0 0 56px;
                    margin-left: 0;
                    width: 56px;
                    height: 16px;
                    border-radius: 0;
                    background: rgba(255, 255, 255, 0.1) url("../../assets/image/icon_PaiXu_8x8@2x.png") no-repeat 4px center / 10px 10px;
                    font-size: 9px;
                    text-indent: 16px;
                    display: flex;
                    align-items: center;
                }
            }

            .infoFilters {
                margin-top: 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 8px;
                width: 100%;
                height: 23px;

                .modeOptions {
                    flex: 0 0 auto;
                    height: 23px;
                    display: flex;
                    align-items: stretch;
                }

                .mode-option,
                .season-filter {
                    appearance: none;
                    -webkit-appearance: none;
                    margin: 0;
                    border: 0;
                    border-radius: 0;
                    box-sizing: border-box;
                    padding: 4px 8px;
                    font-size: 11px;
                    height: 23px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.9);
                    background: rgba(255, 255, 255, 0.1);
                    line-height: 15px;
                    white-space: nowrap;
                }

                .mode-option {
                    flex: 0 0 auto;

                    &.active {
                        background: rgba(255, 255, 255, 0.15);
                    }

                    &.mode-more {
                        display: flex;
                        align-items: center;
                        gap: 4px;

                        i {
                            flex: 0 0 10px;
                            display: inline-block;
                            width: 10px;
                            height: 10px;
                            background: url("../../assets/image/icon_ LinearArrowDown_White.png") no-repeat center / 10px;
                        }
                    }
                }

                .season-filter {
                    flex: 0 0 auto;
                    gap: 4px;
                    display: flex;
                    align-items: center;

                    span {
                        max-width: 70px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    i {
                        flex: 0 0 10px;
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        background: url("../../assets/image/icon_ LinearArrowDown_White.png") no-repeat center / 10px;
                    }
                }
            }
        }

        @media (max-width: 340px) {
            .accountInfo {
                gap: 8px;

                .infoAccount {
                    .infoFilters {
                        gap: 4px;

                        .mode-option {
                            padding-right: 3px;
                            padding-left: 3px;
                        }

                        .season-filter {
                            padding-right: 6px;
                            padding-left: 6px;
                        }
                    }
                }
            }
        }

        .profileCaption {
            height: 13px;
            font-size: 9px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: center;
            color: rgba(255, 255, 255, 0.3);
            line-height: 13px;
            margin: 16px auto 20px;
        }

        .levelGrid {
            margin-bottom: 8px;
            display: grid;
            grid-template-columns: repeat(4, 2fr);
            grid-template-rows: 68px 46px;
            gap: 4px;

            > div {
                height: auto;
                background: rgba(255, 255, 255, 0.1);
                -webkit-backdrop-filter: blur(10px);
                backdrop-filter: blur(10px);
            }

            .grid1 {
                grid-column: span 2;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;
                padding: 12px;
                box-sizing: border-box;

                img {
                    margin-right: 0;
                    width: 40px;
                    height: 44px;
                    flex: 0 0 40px;
                    object-fit: contain;
                }

                .noImg {
                    margin-right: 0;
                    width: 40px;
                    height: 44px;
                    flex: 0 0 40px;
                    object-fit: contain;
                }

                div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 2px;
                    font-size: 11px;
                    background: transparent;
                    color: rgba(255, 255, 255, 0.6);

                    .rrNum {
                        display: flex;
                        align-items: flex-start;
                        gap: 2px;
                        font-size: 18px;
                        line-height: 25px;
                        color: #ffffff;
                        font-weight: 600;

                        span {
                            position: static;
                            font-size: 8px;
                            line-height: 13px;
                        }
                    }
                }
            }

            .grid2 {
                grid-column: span 2;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: stretch;
                gap: 6px;
                padding: 12px;
                box-sizing: border-box;

                .victoriyOrLose {
                    display: flex;
                    gap: 2px;
                    width: 100%;
                    height: 4px;
                    margin: 0;
                    overflow: hidden;
                    background: rgba(255, 255, 255, 0.1);
                    box-sizing: border-box;

                    i {
                        min-width: 0;
                        height: 4px;
                    }

                    .winProgress {
                        background: #5adbc0;
                    }

                    .loseProgress {
                        background: #ef5459;
                    }
                }

                .victoriyOrLoseCount {
                    height: 22px;
                    background: transparent;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .victoryCount,
                    .loseCount {
                        font-size: 16px;
                        line-height: 22px;
                        color: #d7d7d9;
                    }

                    .victoryCount {
                        &::after {
                            position: relative;
                            left: 3px;
                            content: "W";
                            color: #5adbc0;
                            font-size: 8px;
                        }
                    }

                    .loseCount {
                        &::after {
                            position: relative;
                            left: 3px;
                            content: "L";
                            color: #ef5459;
                            font-size: 8px;
                        }
                    }

                    .splitLine {
                        display: none;
                    }
                }
            }

            .grid3,
            .grid4,
            .grid5,
            .grid6 {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 2px;
                padding: 4px 0;
                box-sizing: border-box;
            }

            .inquryText {
                font-size: 10px;
                font-weight: normal;
                text-align: center;
                color: rgba(255, 255, 255, 0.5);
            }

            .inquryValue {
                font-size: 16px;
                font-weight: normal;
                text-align: center;
                color: #ffffff;
            }
        }

        .inquiryGrid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: repeat(3, 52px);

            div {
                position: relative;
                height: 52px;
                background: rgba(255, 255, 255, 0.05);
                display: flex;
                flex-direction: column;
                justify-content: center;

                .inquryText {
                    font-size: 10px;
                    font-weight: normal;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.5);
                }

                .inquryValue {
                    font-size: 14px;
                    font-weight: normal;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.8);
                }

                &::after {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    margin-top: -10px;
                    content: "";
                    width: 1px;
                    height: 20px;
                    background: rgba(255, 255, 255, 0.1);
                }

                &:nth-child(4) {
                    &::after {
                        width: 0;
                    }
                }

                &:nth-child(8) {
                    &::after {
                        width: 0;
                    }
                }

                &:nth-child(12) {
                    &::after {
                        width: 0;
                    }
                }
            }
        }

        .closepall {
            width: 100%;
            height: 32px;
            background: rgba(255, 255, 255, 0.1);
            color: rgba(255, 255, 255, 0.6);
            font-size: 12px;
            text-align: center;
            line-height: 32px;
            -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);

            // 展开
            .down {
                margin-left: 4px;
                display: inline-block;
                width: 10px;
                height: 10px;
                background: url("../../assets/image/icon_ LinearArrowDown.png") no-repeat center / 10px;
            }

            .up {
                background: url("../../assets/image/icon_ LinearArrowDown.png") no-repeat center / 8px;
                transform: rotate(180deg);
            }
        }
    }

}

.noDataValue {
    color: rgba(255, 255, 255, 0.5) !important;
}

@keyframes rotate {
    from {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    to {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}
</style>
